var _style, _path, _path2, _defs, _path3, _g, _g2, _path4, _g3, _g4, _g5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _defs2, _circle, _defs3, _polygon, _defs4, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddictionZoneFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCF6E2;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000173123992780862113410000015019580830752258447_);}\n\t.st3{fill:url(#SVGID_00000003822731115328295580000007956709120978632609_);}\n\t.st4{fill:url(#SVGID_00000136379607404578063670000009464401819245043851_);}\n\t.st5{fill:url(#SVGID_00000050654785980608160090000006970480624632703666_);}\n\t.st6{fill:url(#SVGID_00000042726481183068168120000000873145854943194008_);}\n\t.st7{fill:url(#SVGID_00000029735390112565238640000009949467022001044129_);}\n\t.st8{fill:url(#SVGID_00000031910187862916517500000007352225081883003803_);}\n\t.st9{fill:url(#SVGID_00000060005576040062887380000016475296996719577019_);}\n\t.st10{fill:url(#SVGID_00000069369276819423790080000014045488387467086485_);}\n\t.st11{fill:url(#SVGID_00000169556912132076769240000001929589651380452018_);}\n\t.st12{fill:url(#SVGID_00000028323938611435991790000015947289248942313896_);}\n\t.st13{fill:url(#SVGID_00000138562592564751328290000009520133102100025235_);}\n\t.st14{fill:url(#SVGID_00000052081103344375141580000017733775140602400691_);}\n\t.st15{fill:url(#SVGID_00000017515554618717341660000003684826948118917270_);}\n\t.st16{fill:url(#SVGID_00000034785353203513356640000015317784036157626550_);}\n\t.st17{clip-path:url(#SVGID_00000078761925201469273630000006816722781527917697_);}\n\t.st18{fill:url(#SVGID_00000000210605771833211450000007200499069468391338_);}\n\t.st19{fill:url(#SVGID_00000058553234994703709960000001172400860500141957_);}\n\t.st20{fill:url(#SVGID_00000092454393604776796140000009384354674129137078_);}\n\t.st21{fill:url(#SVGID_00000170275613683606557070000007866003841602965944_);}\n\t.st22{fill:url(#SVGID_00000143603624090711510080000006923271653309964711_);}\n\t.st23{fill:url(#SVGID_00000112604802427832759260000005386257639556940440_);}\n\t.st24{fill:url(#SVGID_00000060019575665397010040000013267505601725744533_);}\n\t.st25{fill:url(#SVGID_00000149360007474664475500000014346982282920793015_);}\n\t.st26{fill:url(#SVGID_00000037654676844350929880000011346835351535069370_);}\n\t.st27{fill:url(#SVGID_00000144337368902463528100000017783141956044189596_);}\n\t.st28{fill:url(#SVGID_00000009552733624787871790000007933638268650771382_);}\n\t.st29{fill:#283558;}\n\t.st30{fill:url(#SVGID_00000156586185288918512540000000457355176293767592_);}\n\t.st31{fill:url(#SVGID_00000067195528376255711940000003239237088865107355_);}\n\t.st32{fill:url(#SVGID_00000074419096037391033110000008379300580985445538_);}\n\t.st33{fill:url(#SVGID_00000168812493085446246990000009643155107692304311_);}\n\t.st34{fill:url(#SVGID_00000183940264477168231120000005939594034569992071_);}\n\t.st35{fill:url(#SVGID_00000115489087159088835830000011594723877312567471_);}\n\t.st36{fill:url(#SVGID_00000083084293104134991890000001567599211915912579_);}\n\t.st37{fill:url(#SVGID_00000124163160642845855220000002137885587954775182_);}\n\t.st38{fill:url(#SVGID_00000159451420552703104600000006358327803029075360_);}\n\t.st39{fill:url(#SVGID_00000058567102785399221910000015117867050516693131_);}\n\t.st40{fill:url(#SVGID_00000039842479400979747650000002565823002861937588_);}\n\t.st41{fill:#8F4D2C;}\n\t.st42{fill:#FFFFFF;}\n\t.st43{fill:url(#SVGID_00000060743587676390904530000014220075225985808281_);}\n\t.st44{fill:url(#SVGID_00000109032055563155744790000001699169610826539650_);}\n\t.st45{fill:url(#SVGID_00000006698054167030857000000011536361045754935464_);}\n\t.st46{fill:#F9F9F9;}\n\t.st47{fill:url(#SVGID_00000039851616982170959110000009673506847725942436_);}\n\t.st48{fill:url(#SVGID_00000075148094418272321320000014563748287167395483_);}\n\t.st49{fill:url(#SVGID_00000029025084469252063870000012637345607256364446_);}\n\t.st50{fill:url(#SVGID_00000150802100798979717160000017257616291555121025_);}\n\t.st51{fill:#E8E2E2;}\n\t.st52{fill:#3C5387;}\n\t.st53{fill:url(#SVGID_00000003078061733310019670000009960366649221130678_);}\n\t.st54{fill:url(#SVGID_00000076565394362950400830000009401497479977264040_);}\n\t.st55{fill:url(#SVGID_00000135670610598396572880000017188143064048090522_);}\n\t.st56{fill:url(#SVGID_00000025430964258754625270000010108316732904796336_);}\n\t.st57{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st58{opacity:0.3;mask:url(#SVGID_00000168801707780142307080000002103676908450174849_);}\n\t.st59{fill:#754C24;}\n\t.st60{fill:url(#SVGID_00000118357635376848857090000005286851285431263644_);}\n\t.st61{filter:url(#Adobe_OpacityMaskFilter_00000032632131149110221610000003148313513158178180_);}\n\t.st62{opacity:0.3;mask:url(#SVGID_00000137818463562210647520000007410460776319879076_);}\n\t.st63{fill:url(#SVGID_00000169517337872865810930000000436014872379548343_);}\n\t.st64{fill:url(#SVGID_00000033361206623807372610000012641306862173234823_);}\n\t.st65{filter:url(#Adobe_OpacityMaskFilter_00000166636181149849234300000014461413063845518512_);}\n\t.st66{opacity:0.3;mask:url(#SVGID_00000079459038954123506600000001871606306509265804_);}\n\t.st67{fill:url(#SVGID_00000037680036598431059920000001352397784643808651_);}\n\t.st68{fill:url(#SVGID_00000119107365336345669750000008973961099672624830_);}\n\t.st69{fill:url(#SVGID_00000011714889442049095060000007001817560594103967_);}\n\t.st70{fill:url(#SVGID_00000043448313184876748520000012539554199380929466_);}\n\t.st71{fill:url(#SVGID_00000119804922246768288880000001039579579203207818_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.49,401.52c40.09-67.62,96.6-118.48,176.76-139.36c155.83-40.6,290.56-4.66,333.21,114.48 c62.67,175.02,111.99,119.96,172.61,184.71c34.51,36.85,71.89,82.15,57.8,166.88c-7.91,47.59-32.32,90-80.36,120.03 c-52.69,32.93-161.35,55.98-289.78,52.69c0,0-290.96-30.66-333.12-78.48c-30.67-34.79-21.56-68-14.14-105.68 c7.08-36.01-33.55-30.74-50.5-97.92C105.15,556.13,113.57,460.42,148.49,401.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.4708,
    y1: 816.6199,
    x2: 886.2426,
    y2: -47.0317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M641.88,735.94c-3.45-0.01-6.26-2.82-6.26-6.27c0-3.06-0.37-308-59.83-471.06 c-41.55-113.93-106.33-122.79-125.19-122.79c-2.2,0-3.4,0.14-3.41,0.14c-0.28,0.03-0.54,0.05-0.8,0.05c-3.15,0-5.83-2.35-6.23-5.46 c-0.22-1.64,0.22-3.29,1.24-4.62c1.02-1.33,2.49-2.19,4.15-2.4c0.02,0,1.72-0.22,4.84-0.22c20.97,0,92.85,9.45,137.18,131 c60.21,165.11,60.59,472.28,60.59,475.36C648.16,733.12,645.34,735.94,641.88,735.94L641.88,735.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042711162958413546160000010473154932305561237_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.4712,
    y1: 816.6201,
    x2: 886.2429,
    y2: -47.0314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042711162958413546160000010473154932305561237_)"
    },
    d: "M641.89,732.64 C641.89,732.64,641.89,732.64,641.89,732.64c-1.65,0-2.98-1.33-2.98-2.98c0-3.07-0.51-308.98-60.03-472.19 c-48.84-133.92-131.29-124.91-132.12-124.78c-1.62,0.2-3.13-0.94-3.33-2.57c-0.22-1.63,0.93-3.12,2.56-3.34 c0.85-0.11,87.91-10.06,138.49,128.65c59.88,164.2,60.39,471.15,60.39,474.23C644.86,731.31,643.53,732.64,641.89,732.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040546136107166491010000002637957593935262381_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.2446,
    y1: 801.3876,
    x2: 865.0164,
    y2: -62.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040546136107166491010000002637957593935262381_)"
    },
    d: "M567.68,735.94 c-3.46,0-6.27-2.81-6.27-6.27c0-3.07-0.39-309.34-34.18-471.93c-16.23-78.11-38.29-106.69-53.94-116.91 c-6.73-4.39-11.83-5.05-14.27-5.05c-0.8,0-1.3,0.07-1.44,0.1c-0.41,0.09-0.86,0.14-1.3,0.14c-2.92,0-5.5-2.06-6.13-4.91 c-0.74-3.33,1.35-6.68,4.67-7.46c0.39-0.09,1.82-0.38,4.11-0.38c4.62,0,11.97,1.17,20.73,6.76c17.8,11.35,42.62,42.28,59.85,125.17 c34.05,163.84,34.44,471.4,34.44,474.49C573.95,733.12,571.13,735.94,567.68,735.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109743755842588256070000008064023391225298312_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.2408,
    y1: 801.3848,
    x2: 865.0126,
    y2: -62.2667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109743755842588256070000008064023391225298312_)"
    },
    d: "M567.68,732.64L567.68,732.64 c-1.65,0-2.98-1.33-2.98-2.98c0-3.07-0.29-309.2-34.25-472.6c-16.46-79.22-39.2-108.44-55.36-119c-10.6-6.92-17.88-5.48-18.18-5.42 c-1.59,0.34-3.18-0.67-3.54-2.26c-0.35-1.59,0.62-3.17,2.21-3.54c0.4-0.09,9.65-2.13,22.31,5.94c17.26,11.01,41.4,41.3,58.4,123.07 c34.08,164.01,34.37,470.74,34.37,473.82C570.65,731.31,569.32,732.64,567.68,732.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055707019254678879180000011067979715514298264_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.4078,
    y1: 835.9504,
    x2: 913.1796,
    y2: -27.7012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055707019254678879180000011067979715514298264_)"
    },
    d: "M208.73,735.94 c-3.46,0-6.27-2.81-6.27-6.27c0-3.46,2.81-6.27,6.27-6.27h495.32c-0.52-44.35-6.61-314.67-76.6-464.28 c-53.52-114.4-137.92-123.29-162.51-123.29c-3.04,0-4.74,0.15-4.76,0.15c-0.2,0.02-0.42,0.03-0.65,0.03c-3.2,0-5.87-2.42-6.21-5.62 c-0.35-3.44,2.15-6.53,5.59-6.88c0.03,0,2.07-0.21,5.89-0.21c26.5,0,117.36,9.41,174.02,130.5 c77.25,165.13,77.83,472.78,77.83,475.87c0,0.62-0.1,1.25-0.3,1.88l-0.02,0.13l-0.18,0.44c-0.27,0.64-0.65,1.12-0.88,1.41 c0,0,0.01-0.01,0.01-0.01c0.02,0-0.16,0.28-0.46,0.58l-0.31,0.31l-0.57,0.35c-0.91,0.72-2.22,1.18-3.56,1.18H208.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032621090758820039370000007844706572670984076_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.4047,
    y1: 835.9481,
    x2: 913.1765,
    y2: -27.7034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032621090758820039370000007844706572670984076_)"
    },
    d: "M713.12,730.75 c0.13-0.34,0.22-0.7,0.22-1.09c0,0,0,0,0,0l0,0l0,0c0-3.16-0.66-310.19-77.52-474.47c-64.74-138.38-175.48-128.53-176.58-128.42 c-1.63,0.17-2.82,1.63-2.65,3.27c0.17,1.63,1.6,2.84,3.27,2.66c1.06-0.1,107.71-9.36,170.57,125.02 c72.3,154.53,76.69,437.09,76.95,468.97H208.72c-1.65,0-2.98,1.33-2.98,2.98c0,1.64,1.33,2.98,2.98,2.98h501.64h0 c0.68,0,1.27-0.27,1.78-0.65c0.11-0.08,0.24-0.13,0.33-0.22c0.08-0.08,0.11-0.18,0.18-0.27c0.17-0.21,0.35-0.42,0.46-0.68 C713.12,730.8,713.11,730.78,713.12,730.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144326410031817950320000006237324813066557326_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.619,
    y1: 678.9435,
    x2: 694.3907,
    y2: -184.708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144326410031817950320000006237324813066557326_)"
    },
    d: "M172.57,735.94 c-3.46,0-6.27-2.81-6.27-6.27c0-3.08,0.57-310.73,77.83-475.87c56.66-121.1,147.5-130.51,174-130.51c3.84,0,5.9,0.21,5.92,0.21 c3.43,0.36,5.93,3.45,5.57,6.88c-0.32,3.15-3.06,5.62-6.24,5.62l-0.63-0.03c0,0-1.67-0.15-4.74-0.15 c-24.59,0-109,8.89-162.52,123.29c-76.1,162.64-76.66,467.49-76.66,470.55C178.83,733.12,176.03,735.93,172.57,735.94L172.57,735.94 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021094763370152708910000014455885078313314989_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0031,
    y1: 708.6416,
    x2: 735.7749,
    y2: -155.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021094763370152708910000014455885078313314989_)"
    },
    d: "M247.63,735.94 c-3.46,0-6.27-2.81-6.27-6.27c0-3.08,0.37-310.24,60.59-475.36c44.33-121.56,116.2-131.01,137.17-131.01c2.65,0,4.41,0.16,4.87,0.23 c3.41,0.46,5.83,3.61,5.37,7.04c-0.42,3.1-3.1,5.44-6.24,5.44c-0.25,0-0.5-0.02-0.76-0.05c-0.04,0-1.24-0.14-3.43-0.14 c-18.87,0-83.65,8.85-125.2,122.79c-59.3,162.62-59.83,467.99-59.83,471.06C253.9,733.12,251.09,735.93,247.63,735.94L247.63,735.94 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178915939436357307320000012444288885671420304_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.1399,
    y1: 738.8796,
    x2: 777.9117,
    y2: -124.7719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178915939436357307320000012444288885671420304_)"
    },
    d: "M335.01,735.94 c-3.46,0-6.27-2.81-6.27-6.27c0-3.09,0.39-310.64,34.45-474.49c17.23-82.89,42.06-113.82,59.85-125.17 c8.75-5.58,16.1-6.75,20.73-6.75c2.3,0,3.72,0.29,4.11,0.38c1.63,0.38,3.01,1.37,3.89,2.8c0.88,1.42,1.16,3.11,0.77,4.74 c-0.67,2.85-3.18,4.84-6.1,4.84c-0.47,0-0.93-0.05-1.39-0.16c-0.05-0.01-0.55-0.08-1.38-0.08c-2.44,0-7.54,0.66-14.27,5.05 c-15.65,10.22-37.71,38.8-53.94,116.91c-33.79,162.59-34.19,468.86-34.19,471.93C341.28,733.12,338.47,735.94,335.01,735.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097481986597887975610000006373208720797928094_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097481986597887975610000006373208720797928094_)"
    },
    d: "M317.53,262.02 c-0.58,0-1.16,0.02-1.74,0.06c0.29-1.93,0.42-3.92,0.36-5.95c-0.52-17.39-14.85-31.45-32.26-31.64 c-11.7-0.13-21.99,5.88-27.87,15.02c-3.67-1.75-7.77-2.73-12.1-2.73c-15.52,0-28.1,12.58-28.1,28.1c0,0.32,0.01,0.65,0.02,0.97 c-2.63-0.8-5.44-1.18-8.36-1.06c-13.2,0.55-23.79,11.47-23.97,24.68c-0.18,13.97,11.09,25.36,25.03,25.36h108.61 c14.17,0,26.12-11.03,26.75-25.19C344.57,274.49,332.51,262.02,317.53,262.02z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000137117130129903005190000015136647377433553283_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0406,
    style: {
      stopColor: "#ECF0F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137117130129903005190000015136647377433553283_)"
    },
    d: "M843.05,245.08 c0.07-11.04-8.78-20.23-19.81-20.58c-2.31-0.07-4.53,0.24-6.62,0.88c0.01-0.26,0.02-0.53,0.02-0.79 c0-12.69-10.28-22.97-22.97-22.97c-3.54,0-6.9,0.8-9.9,2.24c-4.8-7.47-13.22-12.39-22.78-12.28 c-14.47,0.17-26.28,12.04-26.38,26.52c-0.01,1.43,0.1,2.84,0.3,4.22c-0.47-0.03-0.94-0.05-1.42-0.05 c-12.16,0-21.98,10.07-21.56,22.32c0.39,11.66,10.16,20.83,21.83,20.83h88.83C833.85,265.41,842.99,256.32,843.05,245.08z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165952184976457872150000003635462729386946478_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165952184976457872150000003635462729386946478_)"
    },
    d: "M184.7,86.31c-0.42,0-0.83,0.01-1.24,0.04 c0.18-1.19,0.27-2.42,0.26-3.67c-0.08-12.58-10.35-22.9-22.93-23.05c-8.31-0.1-15.63,4.18-19.8,10.67 c-2.61-1.25-5.52-1.94-8.6-1.94c-11.03,0-19.97,8.94-19.97,19.97c0,0.23,0.01,0.46,0.01,0.69c-1.81-0.55-3.75-0.82-5.75-0.76 c-9.59,0.3-17.28,8.29-17.22,17.89c0.06,9.77,8,17.67,17.78,17.67h77.21c10.14,0,18.63-7.97,18.97-18.11 C203.81,95.06,195.28,86.31,184.7,86.31z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132051320368879527280000007799554947443571096_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132051320368879527280000007799554947443571096_)"
    },
    d: "M128.35,209.09c-0.4,0-0.81,0.01-1.2,0.04 c0.18-1.16,0.27-2.36,0.26-3.57c-0.08-12.26-10.08-22.33-22.35-22.47c-8.1-0.09-15.24,4.07-19.31,10.4 c-2.54-1.21-5.38-1.89-8.38-1.89c-10.75,0-19.46,8.71-19.46,19.46c0,0.22,0,0.45,0.01,0.67c-1.77-0.54-3.65-0.8-5.61-0.74 c-9.35,0.29-16.84,8.08-16.78,17.43c0.06,9.52,7.8,17.23,17.34,17.23h75.27c9.89,0,18.16-7.77,18.49-17.65 C146.97,217.62,138.66,209.09,128.35,209.09z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097491716139655194530000009301743941535939743_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097491716139655194530000009301743941535939743_)"
    },
    d: "M371.75,54.44 c-1.5-0.05-2.94,0.16-4.3,0.57c0.01-0.17,0.01-0.34,0.01-0.51c0-8.24-6.68-14.92-14.92-14.92c-2.3,0-4.48,0.52-6.43,1.45 c-3.12-4.85-8.59-8.05-14.8-7.97c-9.4,0.11-17.07,7.82-17.13,17.22c-0.01,0.93,0.06,1.85,0.2,2.74c-0.31-0.02-0.61-0.03-0.92-0.03 c-7.9,0-14.27,6.54-14.01,14.5c0.26,7.58,6.6,13.53,14.18,13.53h57.7c7.31,0,13.24-5.9,13.29-13.21 C384.66,60.63,378.92,54.66,371.75,54.44z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085220664020852851190000002857305928969903277_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085220664020852851190000002857305928969903277_)"
    },
    d: "M730.68,77.49 c-1.5-0.05-2.94,0.16-4.3,0.57c0.01-0.17,0.01-0.34,0.01-0.51c0-8.24-6.68-14.92-14.92-14.92c-2.3,0-4.48,0.52-6.43,1.45 c-3.12-4.85-8.59-8.05-14.8-7.97c-9.4,0.11-17.07,7.82-17.13,17.22c-0.01,0.93,0.06,1.85,0.2,2.74c-0.31-0.02-0.61-0.03-0.92-0.03 c-7.9,0-14.27,6.54-14.01,14.5c0.26,7.58,6.6,13.53,14.18,13.53h57.7c7.31,0,13.24-5.9,13.29-13.21 C743.59,83.68,737.85,77.71,730.68,77.49z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013187401756394996050000011271131655778489741_",
    cx: 512.1654,
    cy: -4.5025,
    r: 688.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66C1ED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013187401756394996050000011271131655778489741_)"
    },
    d: "M938.13,143.34 c-1.5-0.05-2.94,0.16-4.3,0.57c0.01-0.17,0.01-0.34,0.01-0.51c0-8.24-6.68-14.92-14.92-14.92c-2.3,0-4.48,0.52-6.43,1.45 c-3.12-4.85-8.59-8.05-14.8-7.97c-9.4,0.11-17.07,7.82-17.13,17.22c-0.01,0.93,0.06,1.85,0.2,2.74c-0.31-0.02-0.61-0.03-0.92-0.03 c-7.9,0-14.27,6.54-14.01,14.5c0.26,7.58,6.6,13.53,14.18,13.53h57.7c7.31,0,13.24-5.9,13.29-13.21 C951.04,149.54,945.3,143.57,938.13,143.34z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000156571936371787051620000011085121627461040052_",
    d: "M706.43,729.71c0,85.48-418.34,243.68-503.82,243.68 S47.85,904.1,47.85,818.62s69.29-154.77,154.77-154.77c72.47,0,493.57-60.67,510.4,6.59 C716.04,682.51,706.43,716.71,706.43,729.71z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178912226988131406380000000548629073676430729_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156571936371787051620000011085121627461040052_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178912226988131406380000000548629073676430729_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063634199029682703620000001180939327544757125_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.7309,
    y1: 741.9014,
    x2: 626.2012,
    y2: 741.9014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063634199029682703620000001180939327544757125_)"
    },
    d: "M336.54,804.09 c39.93-6.55,82.53-10.62,82.53-10.62l207.13-85.4c0,0-5.58-33.71-46.06-27.78c-40.47,5.94-145.01,43.44-145.01,43.44 l-86.87-3.79C348.27,719.94,313.68,807.86,336.54,804.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049210062071902216380000017329175962125841833_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.0256,
    y1: 757.3015,
    x2: 700.4935,
    y2: 757.3015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049210062071902216380000017329175962125841833_)"
    },
    d: "M410.84,816.93 c39.93-6.55,82.53-10.63,82.53-10.63l207.12-80.27c0,0-5.58-33.71-46.06-27.78c-40.47,5.94-145.01,38.32-145.01,38.32 l-86.88-3.79C422.55,732.77,387.98,820.69,410.84,816.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034048973872839479790000012229050246084243900_",
    gradientUnits: "userSpaceOnUse",
    x1: -29.4742,
    y1: 846.3035,
    x2: 665.946,
    y2: 846.3035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034048973872839479790000012229050246084243900_)"
    },
    d: "M163.5,972.77 c25.67-43.25,48.31-75.37,61.08-80.2c43.88-16.6,131.37-27.92,166.05-41.87c34.69-13.94,140.01-24.02,140.01-24.02l135.31-54.62 c0,0-5.59-33.72-46.06-27.78c-40.47,5.94-114.23,28.06-114.23,28.06l-45.83-19.19c0,0-31.61-29.73-59.82-31.45 c-28.22-1.73-174.18-4.32-195,3.28c-20.83,7.61-37.12,4.61-63.18,32.41C126.42,777.95,25.7,894.9-29.47,972.77 C-28.98,972.67,163.83,972.67,163.5,972.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041290487377422417900000013408525712082406542_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.48,
    y1: 757.6053,
    x2: 646.7769,
    y2: 757.6053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041290487377422417900000013408525712082406542_)"
    },
    d: "M465.48,771.86h40.13l0.17-0.06 c1.11-0.36,111.51-35.52,140.11-23.72l0.88-2.14c-12.39-5.11-40.03-2.68-82.15,7.25c-29.96,7.06-56.96,15.58-59.37,16.35h-39.77 V771.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111898351671405359010000008497884429792052926_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.2682,
    y1: 720.6399,
    x2: 625.5781,
    y2: 720.6399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111898351671405359010000008497884429792052926_)"
    },
    points: "449.27,737.12 509.63,737.12  509.78,737.08 625.58,706.4 624.98,704.16 509.33,734.81 449.27,734.81  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059996706811331369410000014034994547766566587_",
    gradientUnits: "userSpaceOnUse",
    x1: -11563.3877,
    y1: 7945.9961,
    x2: -11455.7109,
    y2: 7986.2856,
    gradientTransform: "matrix(-0.9617 0.2741 0.2741 0.9617 -12584.0215 -4195.0337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059996706811331369410000014034994547766566587_)"
    },
    d: "M612.67,253.6 c15.77-3.05,21.17,32.28,46.39,70.72c0.59,0.9,1.2,1.82,1.82,2.74c13.8,3.64,29.65,7.14,43.68,10.68 c17.28,4.24,32.01,7.29,36.42,8.07c8.84,1.62,10,6.9,2.55,6.99c-3.88,0.09-20.29-0.97-40.94-3.82c-13.9-1.97-29.77-4.16-45.89-7.13 c-2.38-0.44-4.61-1.51-6.44-3.1l0,0c-0.61-0.53-1.17-1.11-1.67-1.73c-2.86-3.56-5.68-7.17-8.43-10.81 C612.03,289.01,600.39,256.94,612.67,253.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052798906718547622600000009902111060691889836_",
    gradientUnits: "userSpaceOnUse",
    x1: -10955.1289,
    y1: 622.1592,
    x2: -10953.041,
    y2: 740.461,
    gradientTransform: "matrix(-0.9229 -0.3851 -0.3851 0.9229 -9228.2676 -4533.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052798906718547622600000009902111060691889836_)"
    },
    d: "M612.63,253.42 c-0.03,0.01-0.05,0.01-0.08,0.02c-1.05,0.35-2,0.86-2.75,1.56c-9.43,8.77,6.97,44.01,23.33,68.59c2.35-1.12,7.57-3.58,9.8-4.89 c4.91-2.9,10.49-6.84,14.39-11.11c-1.25-2.29-13.11-21.32-14.26-23.45C632.01,263.63,623.99,250.55,612.63,253.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062157127094166044700000011825600088338721696_",
    gradientUnits: "userSpaceOnUse",
    x1: 21580.5488,
    y1: 8051.2993,
    x2: 21208.8281,
    y2: 7961.1582,
    gradientTransform: "matrix(0.9616 -0.2744 0.3253 0.9471 -22508.7539 -1363.2322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062157127094166044700000011825600088338721696_)"
    },
    d: "M753.76,351.98 c2.67-1.01,6.19-1.34,5.78-2.86c-0.2-0.74-3.29-0.46-6.12-0.34c2.06-0.85,3.79-1.8,4.78-2.58c2.96-2.36,5.49-1.51,6.52-1.73 c1.03-0.22,4.87,0.23,4.64-1.01c-0.23-1.24-11.16-6.48-16.22-5.82c-5.06,0.67-15.36,8.58-15.36,8.58l2.74,4.45 C742.04,353.87,751.09,352.98,753.76,351.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012445099783771055880000016046441068059292828_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.2908,
    y1: 222.3194,
    x2: 488.3516,
    y2: 786.4073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012445099783771055880000016046441068059292828_)"
    },
    d: "M579.91,372.61 c-17.53,4.14-25.63,14.35-29.49,73.42c-1.31,20-1.62,36.62-0.88,49.97c-0.63,24.72-1.69,28.33-4.08,39.86 c-2.31,11.19-6.97,21.13-11.27,37.41c-0.04,0.16-0.09,0.33-0.13,0.49c-0.09,0.34-0.18,0.68-0.27,1.02c0,0.01,0,0.02-0.01,0.04 c-0.63,2.48-1.19,5.1-1.68,7.84c-3.82,21.13-3.1,71.39-3.67,85.58c-0.35,8.76-1.44,17.35-2.22,22.65l17.07,3.75 c1.64-12.64,6.02-44.86,10.41-65.46c2.89-13.51,9.19-33.07,11.6-49.41c0,0,0-0.01,0-0.01c3.59-20.07,11.36-36.94,18.33-64.34 c0,0,0-0.01,0-0.01c4.29-14.76,8.75-36.67,16.63-65.09C616.62,391.32,597.44,368.47,579.91,372.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088109639389277716460000009707307869026857110_",
    gradientUnits: "userSpaceOnUse",
    x1: 570.4824,
    y1: 206.181,
    x2: 425.5431,
    y2: 770.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088109639389277716460000009707307869026857110_)"
    },
    d: "M538.15,381.16 c-19.1,4.68-29.35,14.56-43.51,69.75c-4.8,18.68-7.97,34.18-9.49,46.57c-4.47,21.03-6.3,25.71-9.99,34.62 c-0.63,1.51-1.53,2.89-2.68,4.07c-3.43,3.55-11.26,11.75-16.86,18.38c-0.08,0.09-0.16,0.19-0.24,0.29 c-0.18,0.21-0.35,0.42-0.53,0.64c-0.01,0.01-0.01,0.02-0.02,0.02c-1.25,1.53-2.48,3.15-3.66,4.87 c-9.13,13.25-20.78,46.43-24.86,55.66c-2.52,5.7-5.75,11.17-7.86,14.52l16.6,5.37c4.8-8.03,17.23-28.48,26.83-41.28 c6.29-8.4,17.59-20.18,24.09-30.52c0,0,0,0,0-0.01c3.16-4.61,9.58-12.11,13.2-16.26c1.79-2.05,3.33-4.27,4.61-6.65 c4.33-8.05,9-16.85,13.82-27.24c0,0,0-0.01,0-0.01c7.03-13.94,15.46-34.55,28.6-61.39C573.47,396.86,557.25,376.48,538.15,381.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106847969496309782720000001680158746406104999_",
    gradientUnits: "userSpaceOnUse",
    x1: -15398.0117,
    y1: -803.1361,
    x2: -15398.0117,
    y2: -127.7667,
    gradientTransform: "matrix(-0.9888 -0.1494 -0.1494 0.9888 -14758.6006 -1288.3138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2675EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0744B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106847969496309782720000001680158746406104999_)"
    },
    d: "M603.31,360.41 c0,0,10.57,23.96,8.23,46.14c-2.34,22.18-22.26,30.83-40.71,27.09c-18.45-3.74-74.73-8.85-63.27-37.86 c11.46-29.01,32.48-44.92,32.48-44.92L603.31,360.41z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M506.08,399.1c0.17-0.87,0.41-1.77,0.71-2.69c0.65-1.99,1.34-3.92,2.08-5.8c0.01-0.02,0.02-0.04,0.02-0.07 c0.18-0.5,0.37-0.97,0.57-1.43c10.23-25.17,26.97-39.55,26.97-39.55l63.74,5.62c0,0,12.04,23.26,11.08,45.54 c0.52,24.05-10.37,76.06-10.37,76.06s-27.23,3.08-61.76-1.49c-34.52-4.57-49.73-9.23-49.73-9.23S497.98,425.37,506.08,399.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034082103496466919770000006624610793309637308_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.7919,
    y1: 419.2886,
    x2: 265.1819,
    y2: 972.3881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034082103496466919770000006624610793309637308_)"
    },
    d: "M419.54,668.52 c10.26,5.14,12.14,1.9,13.38-11.89c0.83-9.3,5.3-25.93,5.3-25.93l-13.04-12.18c-2.01-0.34-14.08,8.77-12.13,18.21 C415.17,647.01,411.39,664.43,419.54,668.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084496203523338062550000005611588809243927720_",
    gradientUnits: "userSpaceOnUse",
    x1: 651.4623,
    y1: 476.4352,
    x2: 382.8524,
    y2: 1029.5344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084496203523338062550000005611588809243927720_)"
    },
    d: "M550.77,726.15 c-11.48,1.22-16.87-13.11-27.29-25.31c-6.93-8.11,3.74-18.65,3.74-18.65l16.83,6.66c0,0,3.5,14.87,7.96,22.65 C556.65,719.61,562.08,724.95,550.77,726.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169529893577196462470000005832311789001654152_",
    gradientUnits: "userSpaceOnUse",
    x1: 5683.7803,
    y1: -6287.4536,
    x2: 5791.4507,
    y2: -6247.1665,
    gradientTransform: "matrix(0.8561 0.5168 -0.5168 0.8561 -7652.1851 2685.1804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169529893577196462470000005832311789001654152_)"
    },
    d: "M567.47,243.89 c-14.41-7.08-28.89,25.6-63.32,56.08c-0.81,0.71-1.64,1.44-2.48,2.16c-14.27-0.1-30.48-0.88-44.95-1.15 c-17.79-0.44-32.8-1.36-37.26-1.76c-8.96-0.76-11.46,4.04-4.3,6.07c3.72,1.11,19.83,4.38,40.5,7.06 c13.93,1.75,29.82,3.79,46.16,5.16c2.42,0.2,4.84-0.24,7.03-1.3l0,0c0.72-0.35,1.42-0.76,2.07-1.24c3.69-2.68,7.36-5.42,10.97-8.23 C558.8,278.23,578.44,250.33,567.47,243.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101066992717426707990000012281194950846323840_",
    gradientUnits: "userSpaceOnUse",
    x1: -9742.7363,
    y1: 240.8669,
    x2: -9740.6484,
    y2: 359.1714,
    gradientTransform: "matrix(-0.9916 0.1295 0.1295 0.9916 -9154.4834 1263.1927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101066992717426707990000012281194950846323840_)"
    },
    d: "M567.55,243.73 c0.02,0.01,0.05,0.03,0.07,0.04c0.92,0.62,1.7,1.35,2.25,2.23c6.8,10.94-18.27,40.64-40.5,60.07c-1.97-1.7-6.37-5.44-8.17-7.29 c-3.98-4.08-8.33-9.35-10.97-14.5c1.81-1.89,18.24-17.14,19.91-18.89C546.18,248.49,557.34,237.97,567.55,243.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079461330724632771840000013893715072015332754_",
    gradientUnits: "userSpaceOnUse",
    x1: -15392.2725,
    y1: -548.1058,
    x2: -15418.1768,
    y2: -974.7554,
    gradientTransform: "matrix(-0.9888 -0.1494 -0.1494 0.9888 -14758.6006 -1288.3138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF86A6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079461330724632771840000013893715072015332754_)"
    },
    d: "M539.57,262.6 c6.67-17.85,21.06-23.53,50.05-19.15c28.99,4.38,41.06,14.05,42.16,33.08c0.54,9.29-10.63,27.61-17.72,45.49 c-7.74,19.52-11.5,38.28-11.5,38.28l-63.27-9.56c0,0,2-16.96,1.64-37.71C540.61,294.78,536.31,271.35,539.57,262.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153668794729618422440000001174067049096515475_",
    gradientUnits: "userSpaceOnUse",
    x1: 8356.4531,
    y1: -831.3545,
    x2: 8374.7305,
    y2: -302.7249,
    gradientTransform: "matrix(0.9888 0.1494 -0.1494 0.9888 -7802.6226 -236.9314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153668794729618422440000001174067049096515475_)"
    },
    d: "M614.33,364.5 c-0.23-28.78,6.99-52,9.27-58.47c0.32-0.91,0.64-1.81,0.97-2.7c4.2-11.59,22.24-41.62-15.79-55.97c-5.29-2-11.66-3.35-19.08-4.47 c-29.17-4.41-43.85,1.25-50.67,19.52c-2.14,5.72-1.52,38.81-9.39,63.86c-11.3,35.97-28.08,78.16-29.48,87.42 c-0.03,0.18,0.15,0.58,0.32,0.62l108.03,16.03c0.02,0,0.03,0.01,0.04,0.01c0.15,0.02,0.31-0.02,0.43-0.11 c0.14-0.1,0.22-0.26,0.22-0.44C609.22,429.8,614.61,399.73,614.33,364.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134949221490936392230000008041556255769585806_",
    gradientUnits: "userSpaceOnUse",
    x1: 5090.2036,
    y1: -6186.2661,
    x2: 4718.5117,
    y2: -6276.3999,
    gradientTransform: "matrix(-0.856 -0.5171 -0.5624 0.8286 1181.9633 8020.3286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134949221490936392230000008041556255769585806_)"
    },
    d: "M405.51,301.81 c-2.32-1.67-5.62-2.92-4.82-4.27c0.39-0.66,3.29,0.42,6,1.28c-1.76-1.36-3.19-2.73-3.93-3.75c-2.24-3.05-4.9-2.9-5.84-3.38 c-0.94-0.49-4.76-1.05-4.22-2.19c0.54-1.13,12.47-3.33,17.18-1.36c4.71,1.97,12.57,12.31,12.57,12.31l-3.81,3.57 C416.32,306.71,407.83,303.49,405.51,301.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078010561149793788070000002531239748807721360_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.5359,
    y1: 789.2524,
    x2: 833.8844,
    y2: -97.4988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078010561149793788070000002531239748807721360_)"
    },
    d: "M449.73,752.4c-3.46,0-6.27-2.81-6.27-6.27 V129.51c0-3.46,2.81-6.27,6.27-6.27c3.46,0,6.27,2.81,6.27,6.27v616.62C456,749.59,453.19,752.4,449.73,752.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011005099393776831720000013144433084298110364_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.4908,
    y1: 650.2515,
    x2: 430.3576,
    y2: 650.2515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011005099393776831720000013144433084298110364_)"
    },
    d: "M419.94,673.87 c0,0,11.21-13.73,10.38-18.29c-0.83-4.57-11.74-28.94-11.74-28.94l-13.08,15.38L419.94,673.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134219490378016685980000011753376483517749431_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.3087,
    y1: 603.6508,
    x2: 421.192,
    y2: 603.6508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134219490378016685980000011753376483517749431_)"
    },
    d: "M306.99,584.19 c0,0,65.87,11.62,73.61,12.04c7.74,0.42,40.59,12.15,40.59,12.15l-17.6,14.74l-81.66-6.14l-33.62-28.64L306.99,584.19z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body_101_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.49,497.86c5.26-2.57,9.29-18.71,7.07-22.26c-1.36-2.18-8.32,3.63-10.11,3.38c0.21-0.96,6.18-5.94,7.03-8.13 c-6.08-8.96-47.22-4.91-54.43,12.97C255.09,491.15,296.74,503.62,308.49,497.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_153_",
    d: "M249.47,504.23c-0.7,16.94,12.1,33,29.19,33.71c17.09,0.7,31.58-14.22,32.28-31.17 c0.7-16.95-12.59-31.25-29.68-31.96c-9.03-0.37-16.89,3.14-22.8,9.02C251.5,484.06,249.8,496.24,249.47,504.23z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x30_6_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neck_4_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031196409452554108000000014423108492900013192_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.6387,
    y1: 555.713,
    x2: 288.5433,
    y2: 555.713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031196409452554108000000014423108492900013192_)"
    },
    d: "M256.66,562.98 c-0.78,3.11,25.87,25.76,26.88,19.16l5.01-38.1l-18.64-15.94C269.9,528.09,259.59,554.61,256.66,562.98z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "body_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neck_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M271.23,534.1l17.56,9.27l-1.79,12.34C272.41,548.05,269.8,539.81,271.23,534.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_31_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "head_118_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face_96_"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M313.49,534.2c-0.9-0.16-1.44-1.39-1.59-3.67c-0.14-2.04,0.05-4.67,0.53-7.42 c0.89-5.07,2.77-10.16,4.63-10.08c0.05,0,0.09,0.01,0.14,0.02c1.91,0.34,1.98,5.83,1.06,11.09 c-0.89,5.07-2.77,10.16-4.63,10.08C313.58,534.21,313.53,534.21,313.49,534.2z M313.24,523.25c-0.47,2.68-0.66,5.25-0.52,7.22 c0.15,2.2,0.64,2.86,0.91,2.91c0.01,0,0.02,0,0.03,0c0.89,0.04,2.75-3.52,3.79-9.4c0.47-2.68,0.66-5.25,0.52-7.22 c-0.15-2.2-0.64-2.86-0.91-2.91c-0.01,0-0.02,0-0.03,0C316.15,513.82,314.28,517.38,313.24,523.25z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_108_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.62,512.33c0,0-9.48-1.34-11.32-1.24c-3.07,0.17-3.81,2.13-4.32,3.18c-0.18,0.36,12.36,2.11,14.21,1.53 C314.05,515.22,313.62,512.33,313.62,512.33z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144299864342459355650000014413001881258727866_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.0049,
    y1: 521.9728,
    x2: 312.8716,
    y2: 521.9728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144299864342459355650000014413001881258727866_)"
    },
    d: "M276.92,518.45 c5.51-15.14,11.99-29.41,22.83-28.96c12.76,0.53,14.11,18.83,12.64,26.01c0,0-0.83,12.55-0.86,13.35 c-0.09,2.16-0.28,4.73-0.63,7.43c0,0-2.81,18.05-7.21,18.18c-6.04,0.18-20.14-3.91-27.38-10.04 c-5.53-4.68-6.45-8.42-6.28-12.41c0.02-0.58,3.47-4.69,5.16-9C275.81,521.4,276.43,519.81,276.92,518.45z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_107_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.45,511.97c0,0-9.48-1.34-11.32-1.24c-3.07,0.17-3.81,2.12-4.32,3.18c-0.18,0.36,12.36,2.11,14.21,1.53 C310.88,514.86,310.45,511.97,310.45,511.97z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035511411220966426780000013842970353700669113_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.3545,
    y1: 526.1977,
    x2: 316.1296,
    y2: 526.1977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000035511411220966426780000013842970353700669113_)"
    },
    points: "312.4,515.51 316.13,534.23  309.35,536.89  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M305.58,533.93c-0.9-0.16-1.44-1.39-1.59-3.67c-0.14-2.04,0.05-4.67,0.53-7.42 c0.89-5.07,2.77-10.16,4.63-10.08c0.05,0,0.09,0.01,0.14,0.01c1.92,0.34,1.98,5.83,1.06,11.09 c-0.89,5.07-2.77,10.16-4.63,10.08C305.68,533.95,305.63,533.94,305.58,533.93z M305.34,522.99c-0.47,2.68-0.66,5.25-0.52,7.22 c0.15,2.2,0.64,2.86,0.91,2.91c0.01,0,0.02,0,0.03,0c0.89,0.04,2.75-3.52,3.79-9.4c0.47-2.68,0.66-5.25,0.52-7.22 c-0.15-2.2-0.64-2.87-0.91-2.91c-0.01,0-0.02,0-0.03,0C308.24,513.55,306.37,517.11,305.34,522.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M310.68,521.25c0.43-0.61,1.05-0.95,1.71-0.92c0.38,0.02,0.75,0.16,1.07,0.4l0.51-0.65 c-0.45-0.36-0.99-0.56-1.54-0.58c-0.93-0.04-1.84,0.44-2.42,1.27L310.68,521.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.93,
    y: 505.75,
    transform: "matrix(0.0738 -0.9973 0.9973 0.0738 -250.2846 771.7219)",
    className: "st42",
    width: 0.83,
    height: 29.71
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026842586302635610210000006315879015102616714_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.6033,
    y1: 521.5002,
    x2: 276.8799,
    y2: 521.5002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026842586302635610210000006315879015102616714_)"
    },
    d: "M273.69,513.03 c-1.01-1.33-3.59-2.38-6.59,1.05c-2.99,3.44-1.65,16.84,5.48,17.14C279.7,531.52,276.45,516.66,273.69,513.03z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.26,485.38c2.02-5.11,5.37-9.38,9.94-12.68c3.67-2.65,8.13-4.7,13.27-6.08c8.78-2.36,16.57-1.95,16.65-1.95 l0.05-0.82c-0.08-0.01-7.98-0.42-16.88,1.97c-5.24,1.41-9.8,3.49-13.56,6.21c-4.71,3.4-8.15,7.79-10.23,13.05L258.26,485.38z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.27,483.96c5.41-0.97,10.8-0.37,16.01,1.78c4.19,1.72,4.61,1.01,0.33-0.76c-5.37-2.21-10.91-2.83-16.48-1.84 L248.27,483.96z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M407.79,735.03c-1.86,0.51-6.89,33.38-3.89,35.09c3,1.71,86.93,3.05,91.8-1.73 c2.56-2.51-0.17-13.59-1.93-14.08c-32.4-9.05-55.93-26.12-55.93-26.12s-8.29,2.97-7.33,7.41l0.99,1.87c0,0-5.23,4.88-10.29,4.41 C416.15,741.41,412.5,733.75,407.79,735.03z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.76,751.74c0,0-17.04,37.06-59.66,34.79c-33.18-1.77-40.07-17.98-40.07-17.98L291.32,734L336.76,751.74z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085251910167814916720000011526418373636585654_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.5094,
    y1: 429.7536,
    x2: 269.5094,
    y2: 959.8698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085251910167814916720000011526418373636585654_)"
    },
    d: "M258.36,558.23 c-18.97,4.45-40.71,47.6-45.14,86.34c-4.43,38.74,9.28,138.13,9.28,138.13s17.25-4.79,27.52-19.27 c14.7-14.09,66.01-70.39,66.01-70.39l10.65-82.79C326.68,610.26,280.51,554.77,258.36,558.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090282904475624745440000006984136372625884073_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.192,
    y1: 749.7543,
    x2: 462.0892,
    y2: 749.7543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090282904475624745440000006984136372625884073_)"
    },
    points: "462.09,749.95 448.01,728.2  421.19,740.86 434.23,761.39 458.07,771.31  "
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.76,751.74c21.16-37.39,46.57-101.49,46.57-101.49l-12.51-50.74c0,0-13.84-4.59-24.91,11.82 c-11.07,16.41-76.42,114.69-76.42,114.69s-15.35,24.06-20.34,40C247.07,772.66,329.47,764.62,336.76,751.74z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M370.82,599.51c0,0,18.29,2.61,29.22,27.12c6.81,15.28,32.92,64.21,51.62,98.89 c-7.67,13.9-35.61,17.67-35.61,17.67c-21.76-24.13-53.18-60.88-58.51-77.47C349.24,639.91,370.82,599.51,370.82,599.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118366533970346745870000011406959813553794741_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.8228,
    y1: 429.7536,
    x2: 330.8228,
    y2: 959.8698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0E0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118366533970346745870000011406959813553794741_)"
    },
    d: "M258.36,558.23 c0,0,20.72-6.09,43.41,7.19c22.69,13.28,114.25,52.02,114.25,52.02s13.37,35.07-7.74,35.75c-31.55,2.21-166.83-45.71-166.83-45.71 L258.36,558.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134235917638444405100000016864006620005136543_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.3466,
    y1: 630.587,
    x2: 430.3576,
    y2: 630.587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134235917638444405100000016864006620005136543_)"
    },
    d: "M421.19,608.37 c3.06,1.3,6.83,5.17,7.75,8.12c0.92,2.95,2.67,18.12,0,23.61c-5.9,12.18-20.11,13.22-20.11,13.22s-4.8,1.05-7.38,0 c-2.58-1.05-2.4-3.07-2.4-3.07s-1.84,0.55-2.58-1.48c-0.74-2.03,2.03-3.14,2.03-3.14s-1.23-0.58,0.25-3.16 c1.48-2.58,9.86-5.03,9.86-5.03l0.83-14.16c0,0-3.57,8.33-8.18,9.07c-4.61,0.74,1.48-13.84,1.48-13.84s2.58-6.64,4.24-8.12 C408.65,608.92,415.1,605.79,421.19,608.37z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M428.76,754.7c-1.98,0.54-7.34,35.56-4.15,37.39c3.2,1.82,92.61,3.25,97.8-1.84 c2.72-2.67-0.18-14.47-2.05-15c-34.52-9.64-59.58-27.82-59.58-27.82s-8.84,3.16-7.81,7.89l1.06,1.99c0,0-5.57,5.2-10.96,4.69 C437.67,761.49,433.78,753.33,428.76,754.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M483.2,760.55c-1.13,0.41-2.21,0.92-3.2,1.54c-5.16,3.2-7.27,8.49-7.94,10.61l1.46,0.46 c0.62-1.96,2.57-6.84,7.29-9.77c1.3-0.81,2.77-1.43,4.31-1.84L483.2,760.55z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M474.15,755.59c-0.32,0.17-0.62,0.34-0.92,0.53c-5.16,3.2-7.27,8.48-7.94,10.61l1.46,0.46 c0.62-1.96,2.56-6.84,7.29-9.77c0.54-0.34,1.12-0.65,1.72-0.92C476.06,756.68,474.15,755.59,474.15,755.59z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 316.97,
    y: 607.96,
    transform: "matrix(0.2923 -0.9563 0.9563 0.2923 -379.9897 751.2531)",
    className: "st52",
    width: 1.29,
    height: 48.84
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M398.51,646.07c0.49-0.01,12.11-0.36,15.03-1.82c1.3-0.65,2.51-2.75,3.58-6.23 c0.78-2.53,1.22-4.92,1.22-4.95l-0.85-0.15c-0.46,2.57-2.14,9.46-4.34,10.56c-2.76,1.38-14.55,1.73-14.67,1.73L398.51,646.07z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M401.13,650.69c2.71,0,10.35-0.09,12.63-1.07c2.71-1.16,7.51-5.35,7.71-5.53l-0.57-0.65 c-0.05,0.04-4.9,4.28-7.48,5.39c-2.56,1.1-13.13,1-13.23,0.99l-0.01,0.86C400.25,650.68,400.6,650.69,401.13,650.69z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022552653703975151940000012654398469631687814_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.2553,
    y1: 748.4868,
    x2: 457.2558,
    y2: 748.4868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022552653703975151940000012654398469631687814_)"
    },
    d: "M280.89,808.47l176.37-108.89 c0,0-14.7-34.86-54.82-30.55c-40.11,4.31-99.06,45.24-99.06,45.24s-59.27-7.45-87.26-4.61c-27.99,2.83-77.17,29.18-88.53,65.08 C116.23,810.65,178.08,854.59,280.89,808.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182486768991160014050000010395246352058674357_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.9439,
    y1: 771.1403,
    x2: 419.1776,
    y2: 771.1403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBAF85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7C44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182486768991160014050000010395246352058674357_)"
    },
    d: "M251.43,820.98 c18.04-3.84,162.61-94.52,167.75-97.72l-1.22-1.97c-1.26,0.78-149.37,93.66-167.01,97.42L251.43,820.98z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169546107911545720560000003877595554219760029_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.8676,
    y1: 712.891,
    x2: 1056.9397,
    y2: 313.5444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000169546107911545720560000003877595554219760029_)"
    },
    cx: 776.54,
    cy: 550.25,
    r: 159.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174603645485773900790000004179444905408166792_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.206,
    y1: 694.0339,
    x2: 1024.4292,
    y2: 340.9884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000174603645485773900790000004179444905408166792_)"
    },
    cx: 776.54,
    cy: 550.25,
    r: 141.19
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 635.35,
    y: 409.06,
    width: 282.38,
    height: 282.38
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 635.35,
    y: 409.06,
    width: 282.38,
    height: 282.38,
    id: "SVGID_00000109012012537781835360000012688378334467164322_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 597,
    height: 598,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAjxAAAR9gAAG6L/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAlgCVgMBIgACEQEDEQH/ xACqAAEAAgMBAQAAAAAAAAAAAAAABQYBBAcDAgEBAAAAAAAAAAAAAAAAAAAAABAAAQQCAQIGAgAF BAMAAAAAAwECBAYABRYRNSAwQFBgEhAToDMURTYhMSMkIjQlEQABAgIFCAoABQMEAwAAAAABAAIR AyEis9M0MDFBcRKjdAUQIEBQYFFhkTIEgaFCE5PBUoOxYiNUM2NkEgEAAAAAAAAAAAAAAAAAAACg /9oADAMBAAIRAxEAAACL04+PLAr4sCviwK+LAr4sCviwK+LAr4sCviwK+LAr4sCviwK+LAr4sCA2 iVeEiaqb3yrZuXqUhdxSF3FHxc9MrCZjzWa+gS6AwWBXxYFfFgV8WBXxYFfFgV8WBXxYFfFgV8WB XxYFfFgV8WBXxYFfEhHyEeAAAAAAAAAAGZIjPa42Y55OX3aKtKy2TT9/UfOcjDIwyMMjDI+fj1Gl pTQp0F034ONRnbYg5KudcI9nAAAAAAAAAAABIR8hHgAAAAAAABmXImXuFnKvZZH6PP7yAAAAAAAA AAAGMjyj5UUSpdm0DiXz0amkWAAAAAAAAACQj5CPAAAAAABkxty19K9cN70MfQAAAAAAAAAAAAAA AAfEbK4OcVDuNeOTJyEMAAAAAAAAkI+QjwAAAAAbh43SUtZr7zIAAAAAAAAAAAAAAAAAAAxkRlF6 ZrnDPPo9CNUAAAAAAEhHyEeAAAACYPDo/vPmPsAAAAAAAAAAAAAAAAAAAAAAPOrW34OIaPWebEeA AAAACQj5CPAAABvHr0/Xsg+gAAAAAAAAAAAAAAAAAAAAAAAA+K3Z/g4jodU5sagAAAAJCPkI8AAH 0evSYy+n39gAAAAAAAAAAAAAAAAAAAAAAAAAB50u8a5wvzu1KMAAAAkI+QjwABZojqhv7rIAAAAA AAAAAAAAAAAAAAAAAAAAAAxkR3Luw1w5G29QAAAkI+QjwB9fM8We8ae+AAAAAAAAAAAAAAAAAAAA AAAAAAAAAPL1wc7ovbOUkQAACQj5CPAPXqFP6ibOQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+aZdd A4h8zUKAASEfIR4+/ibL1atPdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHz9Ck837ZyUiwASEfIR4 6HSOtkv9YyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAefPei185A9/AAkI+Qjyy9Tpt4PoAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAADT3Pg4/BXqigEhrbPqdNndLeAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAGMir8q7TyE0QSEvEWwv3t8/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABrcn67zQpwJC/ UPpRY84yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfNEvlROXPoSvTebdPJYAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAACuWOCOQtgSXUOX9RJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACDnIM 5QCS6hyzp5KgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQc5BHKQbXTuXdLLCAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAABXrBVjmDzG90HntwL/n5+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD FHu3OCkgkJ6B2zsPpqbYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4cq6XyMjASHj7aB2aZp1wM gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYz8lf5NfueAEhHyEeW7pnFuuEmAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAABr+8Mc9re3qAEhHyEefXTuX2Y6znW2QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AD5o1v5QQeAAkI+Qjxsa47BP8x6SewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGM6xX+WWSrgAEhHy EeAbXV+PW46jnX2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFZm+XkF4AABIR8hHgD28R1W1cc6mSL GQAAAAAAAAAAAAAAAAAAAAAAAAAAAB8fUMQnN5CMAAAJCPkI8AAzeqJ7nc/ao2w+gAAAAAAAAAAA AAAAAAAAAAAAAAADzPDm81zw8wAAASEfIR4AABJdR45PHYcxMqZAAAAAAAAAAAAAAAAAAAAAAAAA PkVvZ5mammAAAAEhHyEeAAAAWjpHELUdUzH75kAAAAAAAAAAAAAAAAAAAAAAA+RDObiCAAAAACQj 5CPAAAAGcC09C4pPnYMwU2fQAAAAAAAAAAAAAAAAAAAAB8GYXX52esEAAAAAAEhHyEeAAAAAASfQ eV7B3L153dCRYyAAAAAAAAAAAAAAAAAAMYjTcqkNUDZ0QAAAAAAAkI+QjwAAAAAADM5BDrFh4daj puYWVPVjIAAAAAAAAAAAAAAY8T214amFno8X4mcAAAAAAAABIR8hHgAAAAAAAAG7a6OOySvEbEdS zVpo33n9mQAAAAAAAADBl56RIeFZqpd6fWNc2dYAAAAAAAAAAJCPkI8AAAAAAAAAAA+5SIF1sHKv o7Vt8Xkjrn1zaULrms7hNIv0JBqZNpp+RIoryJlWo8ufjz2JOlxHOdQuEDFj7+AAAAAAAAAAAAAk I8AAAAAAAAAAAAAAAPv1D19A98hjXD48Q8vkAAAAAAAAAAAAAAAAP//aAAgBAgABBQD+Gk//2gAI AQMAAQUA/hpP/9oACAEBAAEFANxdLLG2/O7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7X nO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7XnO7X nO7XnO7XnO7XiXm2uzm9vzm9vzm9vzm9vzm9vxb1bEzndrzndrzndrzndrzndrzndrzndrzndrzn drzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzndrzn drzndrzndrzndrzndrzndrzndrywd+9W1j34LVzS4CsTiKClldgaSLoKmgag6nHbnFgZxYGcWBnF gZxYGFqUd2GpgHIakD6HphW4etTxYXXTBYrXN9bYO/eoDEkGWLWJp8hUtuRKoAeB0QGYPXAZjY4m 4jGJnRPI6JijYuOjCdhNaB+H0ACZLqQCZNpfTJVcmgwscwl9TYO/ela1zlh6GbKXX01vWFWwCQOt ANGiG30aoi44A34fVgIk2sgKmxpvRZekmxlc1zV9NYO/ejYx73a+uSpS6upiGkXUBCjAjYnqXgG9 JWmAZNrURFSfXJcVXsex3pLB370LWucuur0mWuqqghJF1QQo1jWp61zGuSVqgmTcVMRk2GhlQ1VF RfRWDv3oIWtkzH6WpsZkLUhA1rGsT2F42vSdpxHbuqmi5LgSIjvQ2Dv3nMY57tPWTSXaqviA0QGD T2U0YZU21eEdu3rp4jlRWr59g795saKaU/QVZG5C1ogNRERPZ1ajkn6sR2b6qqinAUD/ADrB37zN frTzS6KtjC0EYYW+1yYgzN39ZYZs7XnhE82wd+8vVak04uk0IwMGJo2+2lCwrd9XhyB7LVHgk8yw d+8rS6Qs0mn0YwMYxrE9vINpG7zRDOza6osEvl2Dv3k6bVEnH0uoGAbWo1PcSDa9u80bDs2usJAN 5Vg795Gr1xJx9FpGRxsYjG+5kG0jbDoRyB7CASCbybB37xw4hJZq5omAGMbRt91MJpGWbQtMyQAk cvkWDv3iYxxH1bQoxscDQs93lxmmHadCq4qK1fHYO/eKsaVxya+G0AvednBacVk1D4p/HYO/eHUa 982To9Y0AkTonvKoipYNU04tjCdDk+Kwd+8DGOI+qaVBDENBs97OJCstul+zVRWr4bB37wVnWLJk a2I0AvfdtCacNh1rocnw2Dv35jAcc1Z1TQiaiNT317Uc216lDBIxw3+Cwd+/NT1imNBAgRe/7OKh g2XXLFleCwd+/AROKWr65BBROie/vajm2zVIUT2Kx/5sHfvxWYKyJetjoIPwHbxUMHfwlizPzYO/ YiKq0/WoMTG/VvwErEey5a7qz82Dv2auOsiZooiCB8DscNCgmAUEn8WDv2VCF+00MaDD8D2IUIG0 xP0y/wAWDvyJ1WnQfoFqdG/AyN+zLpC6j/Fg79CEpZVdjIMHwW0REIAzFGXLB36ug/bP1YvoD4Lu g/sBuQ/pn5YO/U2P9zRW/UPwWcz7htoEHLywd+pMf/iYnRnwUydR3YCouWBOu/qAPqBP9vgrk6tu gPsDN2nWx1cfSP8AB7aD7g+q/fZp1tNdb0B8Hs7Osf6r/VTB/stmjZ9Y/wAHsSdQdP8A6hv8v06f 9f4PYv5H91L/AJfqP/X+D2L+R/dTf5fqF/6/wexfyP7rKejLbpH/AGj/AAexL/wf3XZ/6WmvO6x/ g9mf0j/sd/Wbh/0staJ9o/we1mRsf7J+3fr9bBUj/eP8Gd/olyOjQZYO/UuQrgsXq34KVejLtI/8 MsHfqUf6uA77C+Cy3/UNwkfeRlg79V5H6puvJ9wfBduX9YN+f90/LB37Wl/TN0J0ID4LZZP6wSif tkZYO/NX6uqcxHgReqfA3r0bcZv0F+LB37KbO+roz/uL4HNIgw26Z+0/4sHfs0cpY87TyEKD4Hvp SCBtJCyJn4sHfsG9WPqmwQoUXqnwF7vq237H9YlVVX8WDv34qOwURYRkKL4DsToINonLIlfmwd+/ EGQseVXpzTB+AKvRLPsmhDIM45vzYO/fmn7VWrGKhR+/zToIVt2f7SeCwd+/OulOiytBsGmD78q9 EsmzaEUyQ6TI8Fg794Klt1Y6IdDC992EpoRWnauOXw2Dv3giyHxj1vbNOJrkcnvZHoxtn3DRDMVx SeGwd+8Nb2josjVzWnF73uti0At3snTJPisHfvC1ytdVd79mxjtMz3mbKaEdp3Svd47B37xQ5RIp q3u2HEx6Pb7uYqDZZ960LDmecnjsHfvHpdm+DI0u2ZIGioqe6ucjU3+5YAeznvmn8iwd+8iv7t8Q mp2TJA/dHORqbjbMAPd7gk0vk2Dv3k1rfuA7XbAcgfuTnI1NttmAZvd4SUTyrB37yUVWrXLG8T9f sByB+4OcjU222YBm83hJJPLsHfvKRVatfsjwu1u1HIYioqe2ucjU223GBm83pJJPMsHfvM0dgJEf qt0I7GPa9PayFaNNxvRgZud4aYTzbB37zdXuTwiaSxCOwMgZW+0yJYwt3llGFux2p5z/ADrB37zo k08QmjtbXZC2gjtRyOT2VzmtSfthAbvbSvWRJNJf59g7957XOaupsh4rtTYhHaGUMqexKvTJE0QW 7ezCA3aWGRLcqq5fQWDv3oYs2RFfp7aqOgbwJmjOMieu/wBsNKEJNjYQhbt7Y96yJRpL/RWDv3o4 e2lxHam4IuQt8EyClCIiKi+qVUTDTBCTYWEIW7W3K5ZWwkyneksHfvSxtnLjO1twcxYFoAVAbQBU YYb86+k6omPONmSNsASbC0hEmxt5C5InypK+msHfvTjMUSxLHNj5CubUyJagEQG6ARGTQvxCjdnV F8zqiYpRtwk4LMPvADyZawDyfc+uSrBOkKQpCr6iwd+9UwhGKDdTg5GtsoeRrqzpHuIHIK0Adg7B HdibqOuN20d2JsQLn9eDF2IEx23jtxd3HTH2CO3C2gDckXEDUk3ZuSLZLJhtvONjyPevq7B3717T FarZ8xuJuJ6YPe7BipZ9gmco2GLZtguP3mwcq7eeqLOlrilIvsP/2gAIAQICBj8ANJ//2gAIAQMC Bj8ANJ//2gAIAQEBBj8A+99aR93YkyfsTpctv7UkwYx7mtETLJzBY7cybtY7cybtY7cybtY7cybt Y7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cy btY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7cybtY7 cybtY7cybtY7cybtY7cybtUfdJ1SZN2sYf4JN0sYf4JN0sYf4JN0sYf4JN0sYf4JN0qfuka5Mm7W O3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm 7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3 Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7WO3Mm7XM+Ln2ju2Qa0u1BVZR/FDaoHo FXJKAc2OtAbA9lQwey+A9l8B7L4D2XwHsvgPZUsHsobA9lBrYalUJCMBtAZlXln8FBwI19t5nxc+ 0d2mEuWT6oF9WPkgZjdo+qFQey+IWYKhqoCzZDMsypaviF8QjUHsiZYLdSOyNoBQmMLfw7VzPi59 o7s0Ggk+QQOzstPug6Y3aPqhUCzBUDsdKpCNARqD2RdKBafRGLC4DyUHCB8j2fmfFz7R3ZNlgLj5 BAzAWtOhCLEKoVA7VSEaoRLWQPmESwFwGhbLwWnyPZeZ8XPtHdig0RJ0BAvBa06ECWUoVQoAdugQ jVCJDadBCJALmj3UDQex8z4ufaO7CBLadk/qQe9sXaSUKoCgB3FBwRqgxRfLbsu0ELZmto8+xcz4 ufaOy4awRccwCa+cKNDU2qBBQaO5iCE6qDFOfKaS3+1EEQIzjsHM+Ln2jssGSmxOkpr5jYu0koUK A7ogUasYp0yS3ZciyY0gjL8z4ufaOyoa1pDNLk0ltKAA7sIITi1tOgotmCjQ7Lcz4ufaOygqkS4+ 6bVhBQaO7iHBOq50Q4EsjQcrzPi59o7Jte9p2NA802rCCgO8IEJ1WMUaD+3H2ynM+Ln2jsk0lv8A xg+6bVhBQHeUCnVYxRBFQmj0yfM+Ln2jsiGgHYGcptWEFAd6EFOqxRY8VY1TkuZ8XPtHZBstgjE0 lNOzBBo72IITiG06CnS5ggQcjzPi59o7rhjBFxzBNe9tY0koADvgghGbLbBzaRBFpECM4yHM+Ln2 juu2fMbnzakKO+jRFGcxtU/LIcz4ufaO6zRCoDSm0QgFDvqBTqsYhOlkQbGr1+Z8XPtHdUMbSXGA TS4U5yUGjvwgp0xjazaQUQRAjOOtzPi59o7qia5sWg0IUaO/nUZwi8CDXGnrcz4ufaO6jJTc7j+S ZRoQA7+IKeQE5js7TA9XmfFz7R3UE9woJo1IADwAaNCMwCDXGB6vM+Ln2julstoiXGCZRChQ8AEF PMEWOztMD1OZ8XPtHdImERaKAhRo8BOo0JxAg15/Pqcz4ufaO6IDOUxxFJpKA8BEJzwKW0jqcz4u faO6JbIRAMSm0aPAjqNCfLOg0aunmfFz7R3R+6RnNCA8CHUtuGcw6eZ8XPtHKAzlMJGhAeBCE54F Ip6eZ8XPtHKWyEYuEU2jR4GfRoT2H9JI6OZ8XPtHJph8U3V4GdqUwQgDT0cz4ufaORf5lNHgYj0Q dpJI6OZ8XPtHJjoQjSgPAxC2wMx6OZAZz9ufauTIjQPA5T4dHMAP+7OtXJmoeCH6itjTGC+8P/tn 2j03V4IfqKhCnb/qvvDy+5PO8cm6vBDtSh/7F97i/sWrk3V4IdqX+Rfe4v7Fq5N1eCHal/kX3uL+ xauTdXgh2pf5F94n/ufYG9cm6vBDtS/yL73Gz7R6bq8EP1Lb07f9V993l92fauTNXgh8fIrb0bUf zXMj5fcnneuTNQ8DlPj5Ho5nxc+0cmAmlA+BiU5vmYdHM+Ln2jlsRzFNPgYlBgOmno5nxc+0ctnz gUNXgZ2pO/29HM+Ln2jlKf6wTadHgZ9OhTH+bj0cz4ufaOQcNBimU6Ao+BCU8R6eZ8XPtHdAlE/E oHwISv2gY0xP4dPM+Ln2juhlMA6hNp0eBHU6FMdoBgOnmfFz7R3Q14ztMUymNAQPgIlPANKJOc0n p5nxc+0d0/suOY0akD4CNOhftgxAMT1OZ8XPtHdLJgMADTqTaY0eAYp9OYJ8136j+XU5nxc+0d1B JeaW0IEeACYoyWmMc+rq8z4ufaO6jJgMBGDk2mMR3/Ep1MKE+aTGJo1dXmfFz7R3VEl7qWoEHv40 oyWOojT1uZ8XPtHdVs1ug06kytoQI78LingOTpjs7jHrcz4ufaO6wlONUmhCmPfjqYQCcAYsaevz Pi59o7rBzTAikFNlvdWFBCBB76JijKlupOQ5nxc+0d12zWHNnHom1ooOHfBcU4B1OhOmPMSchzPi 59o7INBMJZPsm1oxUR3tEp1aEEXk1I0DI8z4ufaOyLZUxx2Y0EoUxj3rEp1aEE5jTUBpPnkuZ8XP tHZJsma6kZidKFPecSnVoQTpct1Gk5PmfFz7R2SDmmBGYpsmc6BGY+aFPeMSnVoQTpct1Gk5TmfF z7R2TDmmBGYpsqc6BGY+aFaMVEd3RKdWgnS5bqNJyvM+Ln2jsq2XOdV0FNrAxUWnuyLinVoItluI ZpPnluZ8XPtHZZoLiZf+ibWjFAg91EkpwDkS4kMjQMvzPi59o7Lh8pxAGdqax7oO0goU51EdzRJR rAQRZKO04+S25rony7BzPi59o7sAc0wIzEINnGLf7k2sKUCD3HSiSU6vCCLZbiGnSiSYk5z2HmfF z7R3Yg6U4wH6dCDJp2T6oVgYqLT3BElGsEWSTtFbU1xPpo7HzPi59o7sg2HktGgoMmO2XeRQrBUF UdqpUSUawRbKO0fREzHmB0DsvM+Ln2juzAseSBoKDZxLT+SFce6FYKg9lpVJRrBGuPdFsmJ9dCjM eYeQ7PzPi59o7tEZbi0jyQ2jtAICY7ZPqhXHuhWCoKoKz5TOqSqSEawRrj3REslx9EYO2QVGY4uP r2nmfFz7R3a4scWw8ihB+0B5oCYDrCrOI1oVxT6r5j3XyC+QXyC+QXyC+QXyC+QXyC+Y90a4o9VB hJ1I7AI1lHamEA+Si9xcfXtnM+Ln2ju4Ite4EeqomuX/AJFHbj6LP+a0e6z/AJqP7kPRQMxUzXe6 pe4/ie4f/9k=",
    transform: "matrix(0.48 0 0 0.48 633.2 406.64)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mask: "url(#SVGID_00000109012012537781835360000012688378334467164322_)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 776.54,
    cy: 550.25,
    r: 141.19
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098220728625940127380000009594475369568342707_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.7648,
    y1: 427.8585,
    x2: 1179.5308,
    y2: 752.7415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000098220728625940127380000009594475369568342707_)"
    },
    points: "776.54,421.4 667.62,626.63  885.45,626.63  "
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000083060229377067424080000008180062783852635287_",
    filterUnits: "userSpaceOnUse",
    x: 667.62,
    y: 421.4,
    width: 217.82,
    height: 205.23
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 667.62,
    y: 421.4,
    width: 217.82,
    height: 205.23,
    id: "SVGID_00000098212725732260227090000009231444944162919852_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000083060229377067424080000008180062783852635287_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 437,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAaMAAANtQAAFFr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAbYB0QMBIgACEQEDEQH/ xACVAAEAAgIDAQAAAAAAAAAAAAAABQYBBwIDBAgBAQAAAAAAAAAAAAAAAAAAAAAQAAAFAwQCAwAC AwEBAAAAAAABAgMFBAYWQBElNTASECBQIROQMRQjJBEAAQICCQQBBQEBAQAAAAAAAQACIQNAEdKT swR0BTUwMTJCIBBQQXEioRKBEgEAAAAAAAAAAAAAAAAAAACQ/9oADAMBAAIRAxEAAACu+FHkgjxI I8SCPEgjxII8SCPEgjxII8SCPEgjxII8SCPEgjxIPHyPUjxII8SCPEgjxII8SCPEgjxII8SCPEgj xII8SCPEgjxII8fQANHx8hHgAAAAAAAAAAAA95I+i1dpqrjLxAAAAAAAAAAAAAB9AA0fHyEeAAAA AAAAAAAAZvFa2eSXPvFG15ufWRBAAAAAAAAAAAAA+gAaPj5CPAAAAAAAAAAAHLjMlmvUbMGQddQu UeaV6rHXAAAAAAAAAAAAD6ABo+PkI8AAAAAAAAAAA57Cq2ziR7cZAHDngqWtN1a2KuAAAAAAAAAA AD6ABo+PkI8AAAAAAAAAAdnXYiz3LwyRkAAHGsWnxmlfLbqiAAAAAAAAAAAfQANHx8hHgAAAAAAA AAHdsqq7KPbzxkAAAceQrOst0a8KaAAAAAAAAAAD6ABo+PkI8AAAAAAAAAejz20s9p8vsMgAAAA4 wFh85pePvVGMAAAAAAAAAA+gAaPj5CPAAAAAAAAAPVs+r7EPTyAAAAABjIgtYbloZQmcAAAAAAAA AH0ADR8fIR4AAAAAAAA9vjuxZbF0ekAAAAAAAxDTXSadh9ia9OIAAAAAAAAPoAGj4+QjwAAAAAAA ZJDaNavh3ZAAAAAAABjIidY7fphrd2dYAAAAAAAB9AA0fHyEeAAAAAAAJSN2AWKb6u4AAAAAAAAA xGyfA1JXdoa1OkAAAAAAAH0ADR8fIR4AAAAAAOZLbQrl1OzIAAAAAAAAAMZEfrXa9VNWO/oAAAAA AAPoAGj4+QjwAAAAABOw+yCelOHYAAAAAAAAAAAY8Xu4mrKptnWB5QAAAAAAfQANHx8hHgAAAAA7 yc2ZA2w5ZAAAAAAAAAAAADx672dXDUj2+IAAAAAA+gAaPj5CPAAAAAFngdmE57scgAAAAAAAAAAA AB5fVg1rS9wavI4AAAAAH0ADR8fIR4AAAAPYWHY8LZDOQAAAAAAAAAAAAAA89D2HCGnMSkWAAAAA fQANHx8hHgAAAC413ZxMevjyAAAAAAAAAAAAAAAHR34KDQNzawIYAAAAH0ADR8fIR4AAAziTLNf4 qcMgAAAAAAAAAAAAAAAA6qTeoo0xwnYIAAAA+gAaPj5CPAAAM32sbPJPvxkAAAAAAAAAAAAAAAAA dXbgpWut060K4AAAD6ABo+PkI8AAcuM2Wm7xssZAAAAAAAAAAAAAAAAAABwqdu8Bpbos9YAAAPoA Gj4+QjwADnsWr7MPf24yAAAAAAAAAAAAAAAAAAAOHPBVNabq1yVIAAH0ADR8fIR4A7umylqt3i95 kAAAAAAAAAAAAAAAAAAAAHGt2byGlvHcacAAfQANHx8hHgHfsyq7IPZzxkAAAAAAAAAAAAAAAAAA AAAceQrmsd0UEozOAD6ABo+PkI8ery28tNm8vsAAAAAAAAAAAAAAAAAAAAAAAMQU90GmI2+0MwD6 ABo+PkPAezZ1W2EerkAAAAAAAAAAAAAAAAAAAAAAADGRB6w3JRjX7lxPoAGj+vs7S+Wmgyhb1WyW hVxaFXFoVcWhVxaFXFoVcWhVxaFXFoVcWhVxaFXFoVcWhVxaFXFoVcWhVxaFXFoVcWhVxaFXFoVc WhVxaFXFoVfBZq75o4qUZOQhv8Gj/EHZyDIAAAAAAAAAAAAAAAAAAAAAAAAMcQ6+AfQAP//aAAgB AgABBQD/ACkf/9oACAEDAAEFAP8AKR//2gAIAQEAAQUAnJybam8gnhkE8MgnhkE8MgnhkE8Mgnhk E8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8Mgnh kE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8MgnhkE8Mgn hkE8MgnhkE8MgnhkE8Mgnvi4O+1bLRuKfYU2etuDvtURGZxUWo0SEX/5LQaF6y4O+1URRnU1EbGE TddGkbc9HqYe1lwd9qUpNSrYivVFJTJQioYStFxRhLQ80pp3V3B32pg6I6mphqIm2yLYhK0hON3H HKZd1dwd9qEIUtVsRfoimaJtHw82S0XDGE4iqYUw9qrg77UW/QHUPxFGTbZFt9JKmJxu54023NVc HfadptTrlsxhNtsNkhH0cQSk3DHE4itpzp6jU3B32ntyPN56KpCbb+0jTE43c8YpKtTcHfaZhlTz ttxhNoZbJCPstJKTPR5ONyNKdNU6i4O+01tRpuuRlITbfgrmCcbumMPU3B32lpWFVD9uxpNttoJC fApPsmdoCcRKUh01Tp7g77S2xGmtUdTE234q5gnG7oizMjLY9NcHfaShplVNRb8cTbbaSSnxKL2K boCcRMUR0tTprg77SWvFmYoKcm2/JVsk43dEX7oURpPS3B32jjqVVTUwNATbaUklPkMtymaInG5y hOmqNLcHfaIv5Frxf8ULBNt+aqaJxu54v3QtJoVpLg77RRVIqpqYOgJttJepeYy3KYoicbn486d/ SXB32hIjUdrxXqmjYJtvQVDZOIuWMJxt1tTbmjuDvtDC0R1NVC0JNtkWxaGWpCcbuKPNh7R3B32g Sk1qtiLJCKVom29E+2S0XHGE4h9pTLuiuDvtBBUJ1NTDURNtkWxaOTpCdbuWNNpzRXB33nbbU4u2 oom0UzRNo0jiCWm4o4nG6phTD+huDvvPb1AdQ/E0ZNt/600lTE43c0YaF6G4O+8zLSnXbaiybQw2 SEaZxJKTcEeTjdbTqp6jQXB33mtyPN56KpCbb1EhTE43c8WadDcHfeWlYU+9bsYTbbKCQjULSSkz 0eTjcjSnTVPnuDvvLbEabrkbSk23qq5gnG7oiwZbH5rg77yUdOdQ/b0aTbbaCQnVKT7FOUBOIlaQ 6ap81wd95LXjTWqOpibb1lawTjdzxPsRkaT8twd946ClVVVEBHE0hCSSnWGW5TVCTjc1RHTVXluD vvHa0YZigpybb11U0TjdzxRLSpJoV5Lg77xRlIdVUwNATbaU+qdcZblM0RONztCdPU+S4O+8JFud rxhkVCwTbf4FS0TiLmiicQ4hTa/HcHfeGIojqqmDjybbSXqX4B/yJajJxu4aA6d/x3B33gIjUdrx fqikZJtv8J9slouWLJxDzSmnPFcHfeCEoTqaiFoSbbIti/DlaQnG7jjzZe8Vwd990JNarYi/RFM0 TaPxHmyWi4ownEVLCmHvDcHffeAjzqX4eiJtsi2L8WSpScbuaNNpzw3B332bbU45bMYTbdO2TaPx nEEtNxRpON1dOqnf8Fwd99rejjffiaQm2/yJGmJxu5400K8Fwd99WWlPO23Gk2hhskI/IcSSk3BH E4iupVU1R97g77623GG85F0hNt/lV9OTjd0Rhl4Lg776UrCn37djSbbaQSE/lKT7Jno8nG5KkVS1 H2uDvvpbMYa1xtMTbf5lcwTjd0RhmRlsf1uDvvmipzqKi348m220klP5ii9inKAnG5aiVS1P1uDv vm2ItSlR1MTbf51WyTjd0RfsgyNJ/S4O++I6lOpqYGPJttCSSn84y3KaoicbmqFVNU/S4O+H+xa8 WYoWCbb/AEKponG7ni/dC0mhXzcHfCLpTqamCoCbQlPqX6BluUzRE43O0Cqeo+bg74iMztiM9SoW Cbb/AEqlslt3LGktDiDbX8XB30ZT/wB1RCtobSwtPruQ3IbkNyG5DchuQ3IbkNyG5DchuQ3IbkNy G5DchuQ3IbkNyG5DchuQ3IbkNyG5DchuQ3IbkNyG5DchuQ3IbkNyG5DchuQ3IbkNyG5DchuQ3IOL SSZhKFpmqX+t/wCLg76LWhoUcu22TVwtkRXG0MjaGRtDI2hkbQyNoZG0MjaGRtDI2hkbQyNoZG0M jaGRtDI2hkbQyNoZG0MjaGRtDI2hkbQyNoZG0MjaGRtDI2hkbQyNoZG0MjaGRtDI2hkbQyNoZG0M jaGRtDI2hkbQyNoZG0MjaGRtDI2hkbQyNoZG0DuNoOXC2ZVcy24Uk+28RlsYuDvk/wBoL/rBf945 AcgOQHIDkByA5AcgOQHIDkByA5AcgOQHIDkByA5AcgOQHIDkByA5AcgOQHIDkByA5AcgOQHIDkBy A5AcgOQHIDkByA5AcgOQHIDkByA5AcgP/vB/9gV/d8//2gAIAQICBj8AUj//2gAIAQMCBj8AUj// 2gAIAQEBBj8A3CVK3DNMlszU5rGNnTGta1sxwAADoALk83fzLS5PN38y0uTzd/MtLk83fzLS5PN3 8y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/Mt Lk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5P N38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/ MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS 5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTzd/MtLk83fzLS5PN38y0uTz d/MtfTc9XPxHUyoKsiFO3PVz8R1LqHcoOIiUYItPcU3c9XPxHUsGqtrUIIwRmAQ/NN3PVz8R1KDW xJgE0kRMShBGCdBOlu7g0zc9XPxHUoOI/kGCbBVfQwRmtH7pm56ufiOpIY0VkwCaSIofUhOgnSz+ DD9Uvc9XPxHUkTCIDsmw+JgjNaO3f9Uvc9XPxHUhrG9yUyCA+JCdBOlkQrhStz1c/EdSBNIh+EIf MwRmNEWxpW56ufiOo7ZbRXWUyCA+ZCdBObVUCaxSdz1c/EdRxNcO/b9IQ6JgjMaItjSdz1c/EdRm ywK6zH9JsEB0SE6CcKqmkwpG56ufiOowmOEShDpmCc5oiIhVHvR9z1c/EdRWsArFcU2CA6dSdBGo VNcf9o+56ufiOorZjhExQh1SnECIiEWmBEDRtz1c/EdRGtArANZTYIDq1J0EXAVNJjRtz1c/EdQ6 gmvcImJQh1ynkCKLT3BqNF3PVz8R1DaKq2tMU2CA69SdBGYBUCY0Xc9XPxHUIAdzAJriImJQoJCf BOY7u01UTc9XPxHUIGqtrT/qbBVUJ0EZjRCuNE3PVz8R1BDR3JqCaSIoUMhPgnS3dwaHuern4jqC Hkfy0wTYKqiGCM1o7d/1Q9z1c/EdQGsb3cak01ICikJ0E6WR2MP1Qtz1c/EdQBMIgIBNhRzBGa0R FC3PVz8R3XbLb3JTIICjkJ0E6WRUK6xQdz1c/Ed1xNIh+EIUkwTpjRERoO56ufiO6zZY/JimwQFJ IToJzaqgTWKBuern4jusJrh37fpCFLME57RERCqPX3PVz8R3VbLAh+U2CApZCdBOFVTXGHX3PVz8 R3VE1wiUIU0wTnAREQiD3Hfrbnq5+I7qNYBAGKbBAU2pOgiaqmuP+9bc9XPxHdQTHCLooQp5TiBH 8ItPcGo9Xc9XPxHdNraq2gxTYICn1J0EXgVNJj1dz1c/Ed0qgmvcImJQh9hKdBOY7u01dTc9XPxH dIQ/lpTYKr7E6CMwCBgepuern4juiAO5gE0kRMSh9jIT4J0t3cHp7nq5+I7ohxFbWmCbBVfZDBGa B++nuern4jugGjuTUEwkRQ+ykJ0E6W78duluern4jugJhEAYJsFV9mMEZrR27/rpbnq5+I75tY3u 41JkEB9nIToJ0s9vx0dz1c/Ed8xNcIfhNh9pMEZjRFvR3PVz8R3ybLb3JTIID7SQnQTmEQrh0Nz1 c/Ed8hNcO/ZCH2swRe0RbHobnq5+I74tlj8mP6TYID7WQnQTm1fyTD57nq5+I74ia4RPZCH20wTn NEREKo/Lc9XPxHfBssCFcU2CA+21J0E6H8uPy3PVz8R3wExwiUIfbynECIiEQe4gfjuern4jvq1t VYBrKbBAD7fUnQTnAfy4/wC/Hc9XPxHfSpB7hExQh9xKeQIotPcGo/Dc9XPxHfRoqra0xTYID7jU nQReB/J7/Dc9XPxHIAdymucImJQ+5lPgiw9wavruern4jkCewTUBWu67/b+67oxTkXtED3+u56uf iOQJ7of0vJeS8l5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXk F5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeQXkF5BeS8gvJH+kYqr6bnq5+I5fzX/wCKH/Sh /wBr3Xuvde6917r3Xuvde6917r3Xuvde6917r3Xuvde6917r3Xuvde6917r3Xuvde6917r3Xuvde 6917r3Xuvde6917r3XuvdR/6X9V/+/X/2Q==",
    transform: "matrix(0.48 0 0 0.48 665.36 419.12)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mask: "url(#SVGID_00000098212725732260227090000009231444944162919852_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "776.54,421.4 667.62,626.63 885.45,626.63  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.5
    },
    width: 264,
    height: 265,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQkAAAELCAYAAADKoHNvAAAACXBIWXMAABcRAAAXEQHKJvM/AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAHohJREFUeNrsned248gVhFsASUlU 1uTZtTf5AfzTj+NH8+P4p1/A3jS7MztBWVRgMrHnXrF42Q2AASQAVp3TBxolUiPhY1V1o+EcRVEU RVHUvNrif0F99M9/PFvn73eI//jXv7/wF0JIUCUFwRYcVw2JYQAaBAghQa0YCCEQJG9HcIw8X1OU exjAGBpo+ABCcBASVEFACIFAj/FoNGBEBbsKhUJ/NHoy+jIUBhYgAw9EJqBDaBAS1DQYtjKAEAMU Gh4QxDKao9EajW15u0hQIAC6o/E4Gg9yVFgMDEDw/QOASciBEBqExEZDwQeEKACEJhwVAtvyNgIj ed/OaOwCKOIC44ae6Akc7mF0AQoIkAf5d9d8jnUgFhoEBiGxEXCwbiHyuIBmAAg7cFQI7BpQNOFz 2h5IFOUkegKBOxn34Ca65mN3ABQ8qgPpeqAR6joIDEKiNmCwUIhMd9AyDmDHjF3PaAMIWgAWC5UG PGaRTqILLgJP9keARMfAomMGQuQBvhbBQWAQErVzDRYKTXAILYDA3mjsy9gTAFgg7AJEdg0IGp7H aEJ0KSpuoJvAGNE3cUMBcgfHBAw3o3ELRx0WKPem7wgCg7AgJKrkGmJ4dW95XEEb4HAwGocyDgAK 1l1sw/dDEMSeTiM2nYcrGBR9c8TSsgvO4BGg0TFwuDHjWoZChMAgJGrlGlrQD+wBCBQK+wYQBzL2 TN/QMpGiAWCI3fRMyFYADltLhoMFRWgMoF/oeaBxB8BAaCRwuBqNSxlXMvICY0BYEBJldg3qFBQA x6NxIscjAwR1E6GeIfa4hcgDgq01/K6HGe/3AWNgugzsLh4gYqizQFBcBIDRMcB4dNOlJ2FBSJTG Nag7OBIonI7GM4DEIUABuwWcqbBQyAOEsv0+hznAMTBOQ6HxAMBAWKQBw7qMB4BFn1GEkFglHPK4 hlOBwim8fWz6hm03OeUZm6IxqhAQFgFHCBo9cBcYR649wDiXcSHHSwFGx43XZjCKEBIrgUMTXMNe hms4lfcfCTz23PQipzS3sCm/p1C/oSdzz/mnUxEYCofkjP8sx3P52LVxFowihEShcNDpSuwZQq5B wdD2wMGCgb+XfLEkBAyFxZlA4pOA4kwAorDAwtO6iyFBQUjkAYQvVmzLSb4vJ/6JuIXnMk4zXAMu nfaBgb+HxYGhsFBXcQaQOIM4olFEgeGDBV0F/zhT3UMIDkcChwQKL2BotMjjGiL+3xcGDFz+rdOn 2FecQRTROHJhYIExhBGEf6jBaNH0wOHUwOElOAidzszjGgiGYoGBzuLeA4wziSHJ+CgDu4tbN14G zgiy6X+0gWihheS+G5eQCoWXBg44U7EjX0vXsH5g+FZ53gsArgQI2ll8GI0/5PgZnMUdI8gG//Fm RAstJJ8JEF6Nxms5vjBw2BM44PQlXUM5gGEXbWEUuQFX8VEA8bsc1VlcMYKMFW+oe0DnoLHiREDw djS+GY3vRuP70fh2NP46Gm8AFIemd2i48FJoavUvfHbBW+hq2zY4Qbwuxl4UN3H8+9dt9593d3QS G+AeEBDH4B5eCxDeyL+fSe+gsxXoHCK6hspFEY0hD+AqvoCrwMEIsglOIsM9nAoUvhbH8J2Mb+R9 rwES7RTnQFXDWeg2gLjBD27Soy8EtoS2mwo/Lf7aBFexVXM4hABxAPHitUSMt/I2RgrsHegc6uUs 8AKzpHfQNRZJsZmUmu9laLn5yU3OguhS7z9dRZ0dxVaNAeGb1myLK0hmKF4JGL6S4yt5/5G4jB3z SsJCsn6w8O2slSeCnEkEwW36ahs/4hoDQgsrnbU4dtPF5A8SM76WDkIdhEYLO2tBQNQzhtidw3wR xL5oIGhqHT/iOsEh+QVB7mzKL/bA0z18L+MbgcZLgci+iReEw2bAwrnpS/9xFkRnQnDKO/K4kqGA YlgnUMR1AUSgezgS95BEir963MMrNzml2WL3QFcRcBW+fUV9oPjz7QQUdXEVcY0AoQ5C48WJQOAv AffwQtzDHqMFNSMsWm76xkfOTd+ZrBbxI64JILR/2AFAvBb38L24h+8EGHQP1DwRxO5yjlsMxgYU T+soxFVUGhRxDQChv0Cd2nzmxuXk9xAvvhL3cEL3QM3pKuxtFDV6NN1kmTmoU08R1wQQbegfEBAY L57TPVAFuAq7L6ntKCZ6iiqCIq44IFpuPL2p/cN3AAi95iKJFzpzQfdALburaBlQYKE5cT+QKoIi rjgg2qZ/8M1e6NSmneMmHKh5XQUu78Z7tto7p225yStSKwmKuMKA2HPj9Q8aL/5m+ge9MKtF90AV GD8anviBPQXeMqByoIgrDIgTAMQP4CBs/1DkXbUpxo+tFFDE0E/gLRArBYq4BoDQ/uFb6R+SLzgw /QPjBVUkLHw9RdO4ib4ZlQFFXANA/ACA0IJym/0DVYKeAq8exv0sKgWKuOKA0CnO1wAI9g/UunuK CECBs2muiqCIawQILSgbhAO15p4iMq6i0qCIawYI9g9UGWFRaVDEBARFERSVgAQBQREU5QRFTEBQ 1FpBgbMevTKCIiYgKKoUoOgbRzEoCyjikgGi7aaXWhMQVN1B4QwodCgo1rofRVwSQDRdeKEUAUHV GRQx/D1r7HgEUAzXDYrGmgGhi050P8rkqs2/0kFQNQYF7qKmDkJdhN4DRO/p8eQm4LgZTkJ2tU4D hF1qTUBQdXQU6qQj0008wni6reC6+omVQwJchNI0uRgruaxbN4z5m5u+FoOAoOoIClzGrX/XfYgc XRlrLTLjNQFCi8oEALon5bcAiLfyftwshoCg6uwo8G976MY3Nu7a6LHqfqKxBkDYmIH3xfhKYscJ Iwa1QR2F7tN64ibveu51E268lqJeTiJHD6Fb3ifQOHTj/SB4sRa1SfED/94HblxmPiIsVhk7VgKJ lB7iaze5aa3uSbnrpm98QlF1BYQzHUVsYsejcRYr7SfiFQLC10PoztZJD/FG7FbbjTfrYMygNq2f SCsydfRX2U80VgSIUA/xFznqDXsJCGrT+wl124cChPvR6Mi4F0fRA1AUvn6iUCfBHoKiFooeWxA7 +hA7HlbZTxQGCRMztiVmsIegqNnihy0xH2A8XTVaZOxoFAwInd5RF/HSxAzrICL+fVAExNMLePLi eiBwSKLGDYyOMysyi4odUcE/LP6gyb0w3oiTeMsegqJm6ieey3nzlZxHz93krSO25MW5/HEjI2bo bAZ7CIrK30/YbkJjx/0qYkejIEDYmKF3+05AoVd1HghEeHctikp3FLgZUxIzrkfjSo4dAEUhsSMq 6AdDF/FcwIA2iT0EReWHROzGixCfyfn0Vo56x7qn+80sO3YszUkE1kQcS/fwVsYLed+em7wFGl0E RWX3E+jMExdxKUMdRRecxNLcRFTAD4QuIokVrwQQr9zklZ2MGRQ1f+x4KU5Cz6uJfm+ZbmIpxWVg 6TXuEfGtxA0LCboIisoHCSwy1SlogXnnxisydZHV0krMxpJ/EJzyPBXavRJgJDapzZhBUQu5Cb2s /FDOq4vROJfjrSugxFzYSRgXsQNPXl1Esk+l7jKFkCAgKGoxDdx4ufa9OAqdFlU3sfCS7caSAKGE wwb2lQydzdg1LoKiqPnchF1kdSluIhlXbsklZrSkJ45lpU7RvHGTu0wxZlDU8kChJabOdmiJafeF XbjEnBsSGVOeb1x4TQQBQVFu4fM21P89d9P939ZaIBFwETrl+UaeNO5VyZhBUcXFjmdyztnzbmE3 ES34RBUSu5CPtIvQlWB0ERRVDCjw/rnHcv69BDexuww3MRckgEp4D88TyUYhy0NRVPFu4oWMk2V1 E4s6CcxFColnbrz0misrKap4N6FrJ46MmzhchpuYGRKBwlLLEx02ZlAUVYwKdxPznsBbJmocyRM6 BXpx6TVFlcdNzN0LzgSJwH4RhwCII4kZuE8ERVHrcRPPTfQvHhIeF6GLOTRm6HZ0+IQICopaj5vQ jnChbe6iOZ4MUku7iOfwZHbZRVDU2twETiToebnQdGjuExnog0tCj4FYJ268JR3XRVDUetwE9oTo 8OdeXBUt8ET2M2hFUdTqQaFuYl/goJCYe2FjrpM5x7TniePqSooqAyTSJhXabnLt0tKdxKzTnhRF rR4S1k2cwAv5voOZx7yRI5rhwW1heew47UlRZVPkpq/pUEjMVWBmQsJTWOrWWaceG8NpT4oqR+Ro QS1gI8cTJPK4iVmchKXTM3lwu6KLoqj1g0Kvq9qDauBIIsdMd82LcrgIX9Q4kXEMUYOFJUWVy000 wU0cOf8sx1KcRKgx1QfktCdFlQ8StsA8kqHnbCtv5Mh7YmPUOIQHZGFJUdXpJo7k/EX3nxk5ohmj xp6xLbYpJSgoqlyQ0HN3f97IEeV8INwu/1DGvuOeERRVlciBKWCmyJHn5MY+Yh8eZK7VWxRFrSVy tAESGjlaeSJHlINEsck1B+AiGDUoqlqR49D0Epkv8lFKH+HgAZRE++Ai9AEYNSiq/JHDvtDveV7o 53IStrTcl6MWlowaFFUNN6GVwZ6BREPOYxfqJbIggVFjP4VABAVFlT9ybEMi2HemvAydx1EgamAf sQ300VkNXGFJUVT5Iwe+4O/JyDX5EOWwKFh42D6CDoKiqgGK2ESOfTmXM3uJNCdgpz4REpz6pKhq Sc9njBy5eokoB3l2TNlhL+YiKCiqGr1EHIBEai8RpWQYnNloy9ili6CozeolJiABVsN2Ersytt14 6pOlJUVtQC8RpVgTXYChkFBbwlkNitqgXiKtk9B51V1P1GAfQVEb0ktkOQmExI7jKkuKqlMvkatr jALfCCGxI2ObkKCo2vQS6ib2ZoUEvr8B30wBwX0sKar6vUQMBsA3IeGPG56ZDS0ucdBFUFQ9IkcD DEDqRtZRSrnRFDBsu8lZjS3H0pKiqgwKnwnQpPDnuY0zHKHiEq8/1+lPro+gqOoDIlQn2OUNW1lO gjMbFLUZTsJnBIJToHZmo2kyCyFBUfWCxLaBRCsLEvabNGE04IsJCYqqtvCmwttucjX11AxHGiT0 G3m/kKKoyjoJneGIjRnIvU4CZzhiAARCgrCgqHrEjihwjk9CwqyRsL2EvVaDgKCo+jgKe71GqpPw rZFouek1EhRFVR8OzhyDoPBNgeIl4rxmg6I2I3Kkxw3zBaE1EnQSFFXPuNFw0xMUT6suo5Qugmsk KKreDqLhJi+/wIs4n2JHlPHFXCNBUfUFRWyqBe+qyzxToBGjBkXV1klkrroMbTqz5WaYIqEoqnLK veoybY9LHxAICIqqh5PIveqSl31TFGNH6qpLQoKi6ChSKwVCgqI2Fw7O5Vh1SUhQFJUqQoKiKEKC oihCgqIoQoKiKEKCoqhVaEhIUBSVBxRZg5CgKILCDcwYLuokhvx/pahauYgEDD0ZfR8oogAEgtaD oqjagCKBQlfGw2g8CiwGeN77nMQgYEGGdBMUVRupg0jgcDca9/J2V+CR2kmoBel7LAgBQVH16SJ6 4h7uABSPIUgMDRzQfnSNBaEoqh6dhJ7rj+AkemlOwtLlHugyZUEoiqpFJ9EzZkDP8+G//v3F20lg TrGQoJOgqPq5iQEkCO80aBSgC9qPRzoJiqoVHHywCHaOf0JiZCtsTsGs0gXKUBRVHxeRudoy5CR8 FoRrJiiqfqDIXG3pg0SINOwjKKp+LiJztWUIEjgV2nf+dRIEBkVVGxS5VltmOQkuqKKoeir3aksL CS6ooqjN6SJwtWXHBVZb+pwEF1RRVP37CHuOB1dbhuKGtSI+yhAUFFV9J6HLHDAtTKy2DEFiaCCh A4sNR1BQVOWdxIObXjA5tR7qCRKwoMp2Enh1GHsJiqo+KPD81oGXXuReTNWFTkJBQUhQVD2iBtYJ dy6lc0xbJ6Gk6biM9pOiqMpEDbw2Kzmvb7PO7dA6ib5jeUlRdYaEAuLWjTvHmSDB8pKi6ieMGgkk bsBJPMUNnNmYggTLS4qqfR/RhahxAykhuGdMlGJL7DfsZNkSiqIqETXuwEV0xAgEz+msaze6puDo 0E1QVG36iJs8L/xpN+fpAySSb3YFJUdwTpWiqPr0EXmdxB1A4sq4CQKComrcR3ghYcrLHjiJaxm3 WRmGoqh69BFZccNmGIQEd9CmqA3oI/JAYmB6iWv45j32EhRVmT5Cz+NbcBJ3WX1EEBISOdLKjjtG DoqqbNSYKRFECzzAg+NUKEWVHRL4Qn8r5++VOYdTz98ox4MgJPQBMM8wclBU+aMGnr8Iicx76uSB hH2Qy1lJRFHU2qNGR87bCzh/H7P6iFRIpEyFXsq4cdxjgqKqEDVwQeSlvNhjH+EWcRL6YJhprsBN dBg5KKr0UcO+wN+aF/ilQGIAvQRaFq6+pKjyR41bgcPMUSMTEjkix7WbXjNBUVRNokZeJ8HIQVHV jBpYWJ47f5e4VEj4HvQC3ESXgKCo0rgI7CIu4HyduPYqK2rkgkQgcigkztlNUFTpIIHTnol7OAMn cTdL1JjFSdjIoXT6Ik/git0ERZUCEAiJG4HDmYyJDjGPi8gNCeMmtC1NHvyzDLUx3NqOotYfNXpu vPhRITH3ORrN8QR0KvRSnMQnoBQXV1HUemWjBtYCM0eNWSHh3HgX7QewMl9k2LxDSFDU6l1EN8VF PMwaNWaChCdy6CyH5p1LsDOcDqWo1UMCF09dwLl54SaXKsykaI4ng27iGp7MuZtcqEFAUNR6XMQV VAFfnJlYmMVFzAwJcBN984TOPW6C06EUtVoXgTXAZzfuC2/cAptERQs8qR64Ce0mOB1KUet3EQkg PsrxUqLGzIXl3JDImA79JG/fuMm9JggKilqti/joxrOOcxWWy3ASdjpUIWHp1efvkaLW4iJwbcRg 3geJFniCWmDeC62+yJP7ZAjWZ+ygqGq6iLkhYSJH142nXJIn90GO54sWJhRFrddFJGos+ETxoi91 E3+MxuloHI/G/mjsyOMkQNqSQVFUBVzEQnEj4CbOxUn8PhrvBRrXjtd0UFQRLuIx4CLOl+UiluEk rJvQJ3skTuJkNA5Hoz0ardGI6SYoaimAwCuyE+fwSSDxZZkuYiEn4XETj55u4oM8adtN0FFQ1OJd REfOt88S8z+5BZdg+xQv+g3+8+7O/f3rtp706hJicQ670ku0pZtoysciugmKWhgQZxLtf5LxToDx FPEXdRELOwlP7LBrxz96ihROiVLUfIDAshInCnBGcWldxNKcBLgJdBLWTbQDbsLRUVBUbkggID6L c1AX8Zu870YhsQwXkaix5B8kNCWaFJhJmbk3GttuPCUa83dPUTPFDF3hnPQP7yVufBC3vnQX4ZZ5 kho3occIHMWOuIod+TfXTlBU/pihL76X8sL7y2j8KC7id4GEXgoxXJaLKMJJWDehU6IH4iQOxU3Y BVaMHRSVHjPwYso/BAy/SRdx4WBXuGUCwrnlFpehKdEz+aF+Mz/UQpevUtQGxwwFhG+JwdK19E7A TIk6cAmMHRRVoZhRZNzA2GEJuC+RI4kfSYGxzdhBUeWMGYXEDcYOiqpPzCgsbswQO7Ylcmy78XUd jB0UAVGSmLGKuJEVO3TsCigUEjZ+UNQmAgIv3vrgceCFx4zCnQS4CfwPwJiTPHYTnERTAMHVmNSm 9xBdiOiJa/hZXMQvAgy9EVZPz7PKQiIQO4YmejQEEhYULDKpTdLATV68lRSV7wUM/5OY8X6VMWOV ccMXOy4ADCEnse24bJvarJiB50cSK96Ji/hVeonzVcaMlTkJT+zQ/xS8EtQXPVhkUpvWQ2hv91HA 8KOMX+V9yQrm+1XFjJVCwsSOIUBiAB1FE5wFrp8gKKhNAIQWlZ8BEP8TJ4E9xMpixsoh4ekn7E2F YwBF09NPEBRUHSGBC6aStQ+6icx/BRC/u/E+ESuNGevoJGw/offsuHLj5doaNxombvguCKOoKkud dAIILSr/kB4icRK/yb9xa/z+qgGxcidh+gkbPXxTpA0PMOgoqDoCQmcytIfQTWRwt/mV9RBrhYQB hf1PQ1gQFFTdAaFrIXCq80dxEx+lh9CicrgOF7E2SJh+At1EH8bQTa6lICioOgLigwGELpjCVZVr A8RaIREARR9goTMfBAVVZ0D8nAGIwToBsXZIpICiLxaLoKA2ARA41Yn3zeivGxClgARBQREQT4DA LfFLAYjSQIKgoAiIcgKiVJAgKCgConyAKB0kCAqqBsLZusoDopSQICioGgBCl1p3qg6I0kKCoKAq DIie86+krCQgSg2JBUGx5Xj1KLXa/gGv5gytpKwcIEoPiZygwJWZOOzFYIQFVWT/oBvGJJd7f/EA 4pcqAqISkJgBFM4Awhc7CAqqiP4BN3pOLsrCfSntSspKAaIykMgBir6b3DsTR+R5H0Utq3/APSl1 R6mfABDvXElXUtYOEimg6AEo7JWkLgUQhAW1rP5B94LQHaX+K6CwW+BXDhCVg0QOR9Ez0EAgRJ7o QVBQy+ofNF7oDIbuB4HbzlUOEJWERIajeIShsBhmOAq6CmqWeKHTm1emf8AZjN8FHsmGMfeuJFdz bhQkPKAYABQexQY+Kr0DESSiq6BmcA++ePHO9A+/uvEMxg28WA2rCohKQyIFFF3jKBQWvZS+gq6C CgFCZy/uxRnoCkrc0fpH6B8uHcxgVB0QlYdESvRAUDxkOAu6CirLPXTc+D622D9gvJjqH5JvVnVA 1AISAArnJu/nobBQSNxDPuzSVVAzuoe0eOHtH9axaS0hkQGKlPiBkFBo0FVQedzDZzdePfmTG9+X 850b33qvNv1DrSGR0lPgzMe9GXQVhIN9QdGZC3QPOL35i0Djk0CkA4BwdQNELSFh4oczoJjVVVhH QVDUCxB4J+97cQQXHvfwI7iHDwKQm7rGi42AREr8yOMqcOWmMw6DEaR+7sGue9CZC4SDlpPoHh7q Gi82BhILuApciGXdxZCwqFXvkLz0XweihV6Ypd2DuofazV5kaaP+yP/5j2f6MyflZLL3RHLv0YQg B6ORfPDlaLwejTdyfCnvPx6NQ/nc5L6keDNj3p+0OnDAGa87Ey/+kIjxXtzEJwFD4jBuwW3WYu0D ncRiruJO7OSdjHvoLXp0FpUCg40Vd57eQac1NV5otNALs24MINwmAcJt8h91wFXsiqs4Go3T0Xgu biIZL+Tfz+TjIWfBkrM8cMCFdQqIxBmcCyQ+iYP4Q6DwWT52JZ//gC8MmwaHjXQSOV3FA9jRjvxh 3cq4gz8e6yyGnj9YwmI9rqEbcA4fxDn8Au7hZzeetdBVk7fQTQ020T3QSaS7ilicQUucwp44hxNx Ei8CzuJAPn870FkQGMXCYeAml+Mr5K8FEl8EAh/BNXyRj11D70A4EBKZoPDBIokh+xIxQrA4EVjs y+dvy9e2ArDg//38YED3Z6e11f1diytI4sOZRItPAoczef+1fL6Fw5BwICSWCYvnAIqkx9CZkH1x IbvGXUQExtxgyHINNwCGcwDEmbiGM/m4OocHAwe6B0KiEFgcS+R4JpA4FYCcyMcODCxabrz9P4GR DYW0xXDWNVwAFNQtXMi4ks/tEA6ExKphsefGMyLHMk4NMLSz0CiykwMYbkOgYaeTB276al6cpXjI cA16VDDcuvGUti2cCQdConBYNORE3/EAQ90EggJhkXyuTqG23GTZGadAo8q/N9/6koHHLSgUMFKo c7h14zIy5Bo0TtwZ19AnHAiJdcBC11k0ARhtAcERjGPz70PoLnZNHGnK8N1saKsi4EgDgoOT1RaQ voVtCocbAMR5hmt49LiGIeFASKwLFj53oYuzFBgHMg4NMA6ht2gbYGxnuIzQ3hc+cGwVCALf20Pn n6bUV/MeQAHhgCWkQgHfvpKYoYOugZCobBSJwRHseCLJAbiJAxNDFBht6DBaxmUgNLYMNCxAivxd 25Jx4Bl9DxAewTE8QNfQARhcydsKgltwFLi4ja6BkKi0u9A4gg4DgYFjH477prvAwhNdBi7aaoCb QYAU+XsO3SypZ9zCgxl3noGdwxXAQSPEvfkeXboGQqLuwEBo7EA8aXsAsguj7abXX2AvogCxXUZR kMC1Cw9ucpdy/XcICp0UWHTc5AV2CIU+XQMhUTdYuAAwYjjRFRw7Bhy74CR2PTFEvx5digJEH8sV DAl1DHj17KObvhYGP67HewMX3w7nuLcHwUBIbBQwsMeIAtBA14HOYxscRNNAQq9OLTpy2I1c7t3k UmfsHnxAwD6h5yZvAo1gmLiIjnAgJDYRGC4FGtg1IDzs+7EkbYGTWAUk+m66jOya4QOCLzpMuAVC gZCg8kEDYwqun7DTr003XWi6giHhu0zbbgGYBoQpp0AwEBLUbNBwzr9cOwo4EDuzUfTshnUUOoYp MCAQCAlqReBwKe5jFb/rrEVUjkAgJKjyA2RVIgwoiqIoiqIoiqKovPq/AAMAJ0KWfniwZP4AAAAA SUVORK5CYII=",
    transform: "matrix(0.48 0 0 0.48 713.24 498.2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054958826108091530750000015670897851480729475_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.4569,
    y1: 333.6256,
    x2: 1171.0585,
    y2: 892.7109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000054958826108091530750000015670897851480729475_)"
    },
    cx: 776.54,
    cy: 561.82,
    r: 60.18
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083078506817651771530000014836199399037949887_",
    gradientUnits: "userSpaceOnUse",
    x1: 842.8241,
    y1: 602.2862,
    x2: 557.4649,
    y2: 428.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000083078506817651771530000014836199399037949887_)"
    },
    cx: 776.54,
    cy: 561.82,
    r: 50.92
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000181065320105833605000000018374265716142657209_",
    filterUnits: "userSpaceOnUse",
    x: 725.62,
    y: 510.9,
    width: 101.84,
    height: 101.84
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 725.62,
    y: 510.9,
    width: 101.84,
    height: 101.84,
    id: "SVGID_00000047745987584757249550000001018276637438405567_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000181065320105833605000000018374265716142657209_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 221,
    height: 221,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAM2AAAGMgAAC27/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAN8A3wMBIgACEQEDEQH/ xACqAAEAAwEBAQEAAAAAAAAAAAAABQYHBAEDAgEBAAAAAAAAAAAAAAAAAAAAABAAAQMDAwIGAQUA AAAAAAAABQMEBgABAjQ1FiBAEDASExQHEXAyMxU2EQABAgIDCwkFBgUFAAAAAAABAgMAESEEdEAx QRIio7PTNLQFECAwUWFxgbETkdEychShweFCI5NSYpIzFbLCY3ODEgEAAAAAAAAAAAAAAAAAAABw /9oADAMBAAIRAxEAAACL44+PLAr4sCviwK+LAhrMcX6uU0Z5+9M/RmPz1L8GUfnTYIp7prZNq+LA r4sCviwdlTkBHyEeACTOG5WudODv9AAAAHkbJjL6jvtbMkd3CAJCPkBHyEeCTOvU/e4AAAAAAAAj cn2qMMSd3CJCPkBHyEefbXavoh6AAAAAAAAACtZNvuYFPkI+QHx+1jNA7fPQAAAAAAAAABGSfhgv XLxA0vOteOwAAAAAAAAAAAFPz/XMmO7W8u1Q9AAAAAAAAAAABz5PreVn01TItaPoAAAAAAAAAAAD 5ZXqWTnJr+NacWIAAAAAAAAAAAEbkt+z0Was/M3P3l6gAAAAAAAAAB57GGdw3L1CPkI80K+4RsJL gAAAAAAAAA8zO15IfiQj5AR8hHiZhhu3Vj+rHUAAAAAAABHslPlHAkI+QEfIR4AmYYbTLYReDQHL 0noAAADziO2Bq1MO6MABIR8gI+QjwAADstFLGuy+F9RuX6xzsNX/ADlXCa1DZdzFwrHMAAAEhHyB /9oACAECAAEFAP1E/9oACAEDAAEFAP1E/9oACAEBAAEFADE0krYvzuV1zuV1zuV1zuV1zuV1zuV1 zuV1zuV1zuV1zuV1hN5epdKTT1XHkH2DXIPsGlZRO0bZzeXp353K653K653K653K653K653K653K 653K653K653K6FzSSuHMg37ras3TvMXAX7mmUAFIUgBGIVg0bYW9hGvjo1mya505j4xzZ79ejVaJ QMi0pds4b5dYTWyDfulu2XcqAoCqrdkFYMsbWtbyb2tlYgBHv0z0EctclElEs+kJrZBv3QGAvC6o OLsRaVrWtbzMsccrH4gyJJlRLoW46AmtkG/eMbjK5hUWJajG/YFwrQmgeAOQ7nxCa2Qb94AQypd4 KGIDWvZGxCJNoWFOBbrwCa2Qb9TRsq7cRgEkKZdpLwCZJkqnmkpQTWyDfqgAGyl7Wta3aZY2yxnY HJq5oJrZBvw1nm+eimWDJl2x4em/HuUMm7gJrZBv316Lsu67fK1srToZdoSCa2Qb9CGPxRPcfYTL 3RoTWlUrrSgUjZFj3Eib/IFhEsv7K6WSs2Rx9KXcPsPW0DoXwlDC35nWP7e4cfwDP9oPv+J1j+3u HH8Az/aWWyRmyOXqS7h7n6Gohe2cqKKZJSkYr7rLuD7j2BgRa/8AaSDfoW/s8E9x9gP7IDQmtkG/ fXZT2l+3ve1rTwj8okE1sg34S9uxIDnWDpp2x4jgPYPHObtyE1sg36oAetlh2uWVsbT058hagmtk G/UxeKsXUdNIlWXaS08mNZLLKLq0E1sg37wjR1US8YP0XyHZFyzcY2OF1SrzwCa2Qb94xmTLiV2D 9B8j2BYu2GNz59yYc+ITWyDfugFJXghULImRVHzb3taxyUshiRk68Lq9ATWyDfulm+dMVQM/tldq QaO8PJ/P4p8XZMsD09UVpw4WcqdITWyDfutmWIMbjfsRylTCaiXdkirBa2KyWVerGvXjV10caWLM EbEJyKaUU+wXi93hF4+z6wmtkG/eU3uTxui7leGViszrIrM72UcynK61yN/LCa3/2gAIAQICBj8A RP/aAAgBAwIGPwBE/9oACAEBAQY/AK9VmK7iMs1h5ttPpMmSELUlImWybwjbsyzq427Ms6uNuzLO rjbsyzq427Ms6uNuzLOrjbsyzq427Ms6uNuzLOrjbsyzq4k3XCsi/isMnyajGbeWR/0Mjzbj+4v9 ljVx/cX+yxq4m48sA/8AAyfJuJOVwoJvYzDI82o27Ms6uNuzLOrjbsyzq427Ms6uNuzLOrjbsyzq 427Ms6uNuzLOrjbsyzq427Ms6uFtvV3GSmr1pwD0mRltVd11BobwKSDHE7W/pFdAEVdtTh7BQPGA utH00/wj3mAXU+oqc8qnzjIZT7IkltI8I+AeyPgHsjKbSfCJLZT7ImwPTODFogqYPqpGA3/sgpfb U2RRlCXQOWSu7o/HE7W/pFc4NMIK1qMpAecJer5yb/p4PGAGm0gjDKJCjoZETEFDrSaeyFO1HKbv lB+6Ch1JQsXwRI85yyV3dH44na39Irm4rQKWwcpcvKBJALmEm/OJCgdLJQmDghS204j0qFC/BZfS cWeQvAea5ZK7uj8cTtb+kVzAtYKauMN7GhLLKAJCU7hUh1AKiKDKClQJYJyF9XYeY5ZK7uj8cTtb +kVyhlMw2kjHV90IYaSBigCi41tLSCogyMKYeBxZ5C+scrlkru6PxxO1v6RXIirtCa1mQ7IQJfqE UnDO5VLQkesgTSe2FNLEloJBHaORyyV3dH44na39Irk/yDyb/wAE+qJC9cpSaQb8fXNJ/TVQsDz5 HLJXd0fjidrf0ioaqyR8Zyu7DDbKBKQFzutKE8kw4woSLaimnshyyV3dH44na39IqFVxaaE5KT53 QQbxj10iSHaPEUw5ZK7uj8cTtb+kVDZIAUoTMus3SXxfbyp90OWSu7o/FdaAxsevPAjs9VU4aQBK SRdLyJTMjDjP5/pq6jx+lfEVpKROVefJ7vUXCB1AXS6nrSYcYJmSitifzVd73xXbVWNKYHddLnym F/LWd2diu2qsaUwO66XPlML+Ws7s7FaUnDXX0nu9RcIPWBdLiupJhx+VARWz/TV3vdFdcSZFNeep /wDVUNLnPJF0vL/lMOPyp+nrq5dv0r6o4na39IqG6cpIkR2i6VMg5TmTRfphyyV3dH44na39IqF1 JZkk0p8boJN4QGEmaW6T33hDlkru6PxxO1v6RUM1gGQSqSu4w26kzmBc7jqjIyMOVhZpWSfDBDlk ru6PxxO1v6RXJ/j3lZSPhJwjBcxUaAIFSaVkilcuocjlkru6PxxO1v6RXIistGSkGntGEQhxCpqA pFyrSlX6ihIAX5mFPOGa1majyOWSu7o/HE7W/pFcqSVH6dRyh1HrhLrSgZidFxrddUAQIU8on0x8 CT58rlkru6PxxO1v6RXMS24omrE/0/hCXWlAzE6LhU66oAgQVKJDAOQjr7TzHLJXd0fjidrf0iua lIUVVedKcI7oSttYCjfHTTJkIUMcFzAMM4xnSUtg5KJ+fNcsld3R+OJ2t/SK5wdqzhQoYMB7xCWK +MQ3gqdBgKacBn29FTBU64BLBOCzw+9eK8H4wXXllayZzP3c5yyV3dH44na39IroAau8pIH5b4gI raJp/iFMD9QJVhBoMAodSZ9sULB8Yvj2xfHtilYHjBK3U0X6YISsLUMApP2QUVROKk3lH3QVVl0r n+XB7Ogcsld3R+OJ2t/SK6NJq3rUfDiBRHsEBSEVpUsHpKI/0xs1Y/Yc90U1asfsOe6CVprQnfHp qH+2FF/1pfmx8aX29G5ZK7uj8f/Z",
    transform: "matrix(0.48 0 0 0.48 723.44 508.88)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mask: "url(#SVGID_00000047745987584757249550000001018276637438405567_)"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 776.54,
    cy: 561.82,
    r: 50.92
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003073897756820461140000007639276927011195536_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.1906,
    y1: -188.1964,
    x2: -348.5441,
    y2: -535.3679,
    gradientTransform: "matrix(0.9407 -0.3393 0.3393 0.9407 706.9442 428.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572E1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C69C6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003073897756820461140000007639276927011195536_)"
    },
    d: "M640.42,221.48 c5.24-15.31,1.59-34.09-3.41-49.06c-3.66-10.94-9.81-21.33-18.99-28.31c-7.14-5.42-15.92-8.58-24.86-9.27 c-5.25-0.4-10.7-0.01-15.61-1.92c-12.64-4.91-7.11-19.92-1.16-28.01c19.36-26.3-28.65-55.22-41.29-26.64 c-9.97,22.53-21.17,14.41-40.74,6.79c-21.32-8.29-45.19-3.13-62.64,11.25c-9.12,7.52-16.53,17.43-19.75,28.8 c-5.78,20.39,2.43,41.19,16.16,56.4c8.68,9.61,19.46,17.13,31.43,22.06c10.55,4.34,21.99,5.35,33.09,7.54 c6.28,1.24,16.13,3.38,18.91,9.89c3.24,7.58-0.42,15.35-0.06,23.16c0.58,12.48,16.93,26.26,32.84,21.1 c18.11-5.88,15.32-20.45,25.36-22.53c14.83-3.07,18.84,3.06,28.47,5.17c17.3,3.79,32.68-5.71,40.37-21.83 C639.25,224.59,639.88,223.05,640.42,221.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029022299600792207930000002236794795456590980_",
    gradientUnits: "userSpaceOnUse",
    x1: -2331.626,
    y1: -635.4543,
    x2: -2206.1633,
    y2: -799.2751,
    gradientTransform: "matrix(0.976 0.2204 -0.2166 1.0469 2637.5022 1499.2064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029022299600792207930000002236794795456590980_)"
    },
    d: "M590.43,212.72c0,0-0.02,8.12-2.46,16.11 c-2.43,7.95-7.41,13.21-7.41,13.21c-0.73,0.24,3.72,7.35,11.26,9.62c9.39,2.82,12.24-1.77,12.45-4.58l0,0c0,0-1.13-4.91-0.47-14.02 c0.82-11.41,4.23-15.99,4.23-15.99L590.43,212.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147928899552898501290000007081482344060737181_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.9617,
    y1: 360.485,
    x2: 221.307,
    y2: 360.485,
    gradientTransform: "matrix(-0.9821 -0.1885 -0.1707 0.9855 846.5908 -110.501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147928899552898501290000007081482344060737181_)"
    },
    d: "M608.04,186.23 c-22.2-4.47-27.77,15.71-22.87,25.54c4.49,9.02,7.15,5.25,9.18,12.13c1.56,5.3,11.15,11.38,16.32,11.9 c5.17,0.52,12.17-7.74,12.28-23.88C623.04,195.63,616.17,187.87,608.04,186.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000902999518844804080000002327102985696948120_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.2188,
    y1: 272.5905,
    x2: 288.6656,
    y2: -51.4369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#572E1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C69C6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000902999518844804080000002327102985696948120_)"
    },
    d: "M580.46,196.42 c3.32-8.8,11.45-13.74,21.25-13.42c0.93,0.03,1.86,0.11,2.78,0.23c3.62,0.19,6.66,1.46,9.57,3.19c1.65-0.08,2.72,0.16,2.72,0.16 s7.72,0.12,9.76,7.6c2.05,7.48-4.31,9.1-4.31,9.1c-3.04-1.08-10-0.77-15.23,0.63c-9.01,2.41-12.55,8.66-12.92,9.42 c-0.61,1.87-1.19,3.75-1.85,5.62c-0.14,0.4-1.89-0.56-4.06,9.15c-0.29,1.31-3.31-2.42-3.59-2.76c-5.6-6.8-6.94-17.28-5.1-25.63 C579.74,198.57,580.06,197.47,580.46,196.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132062606672863502570000002781026418031320983_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4358,
    y1: 345.0784,
    x2: 149.4436,
    y2: 392.8665,
    gradientTransform: "matrix(-0.9821 -0.1885 -0.1707 0.9855 846.5908 -110.501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F4D2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132062606672863502570000002781026418031320983_)"
    },
    d: "M594.48,214.66c0,0-4.38-4.22-4.69,0.77 c-0.3,4.98,4.68,6.28,4.68,6.28L594.48,214.66z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddictionZoneFinal);
export default __webpack_public_path__ + "static/media/addiction_zone_final.3d835dde2f3c961f1b540fda721b4e22.svg";
export { ForwardRef as ReactComponent };